import {
  Box,
  FormGroup,
  Table,
  Typography,
  Select,
  MenuItem,
  TableCell,
  TableRow,
  TableBody,
  Dialog,
  DialogTitle,
  DialogContent,
  InputAdornment,
  DialogActions,
  CircularProgress
} from "@mui/material";
import CancelIcon from "@mui/icons-material/Close";
import React, { useEffect, useState, useRef, useMemo } from "react";
import { momentLocalizer } from "react-big-calendar";
import moment from "moment";
import AxiosInstance from "../../utils/axiosInstance";
import CloseIcon from "@mui/icons-material/Close";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { handleAuth } from "../Login/Auth";
import { getItem } from "../../utils/storage";
import NoData from "../../assets/image/NoData.svg";
import {
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  Col,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  TabContent,
  TabPane,
} from "reactstrap";
import InputText from "../InputFields/InputText";
import { DisplayImage } from "../Files/DisplayFiles";
import { Files } from "../Files";
import "./style.css";
import "../../styles/fullCalendarTodayIndicator.css";
import { Grid } from "@mui/material";
import { Row } from "react-bootstrap";
import { parseLocalDate } from "../../utils/dateUtils";
import { formatUSD } from "../../utils/usFormat";
import showToast from "../Toast/Toster";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import BlueButton from "../Button/BlueButton";
import WhiteButton from "../Button/WhiteButton";
import InternalNotes from "../FormShell/InternalNotesAttachments";
import DatePicker from "../DatePicker/DatePicker";
import dayjs from "dayjs";
import { LoaderComponent } from "../Icon/Index";
import VisitCal from "../../assets/Blue-sidebar-icon/Visit-cal.svg";
import ProgressVisit from "../../assets/Blue-sidebar-icon/Progress-visit.svg";
import BasicInfo from "../../assets/Blue-sidebar-icon/Info-visit.svg";
import VisitCalWhite from "../../assets/White-sidebar-icon/Visit-cal.svg";
import DonorNoData from "../../assets/Donor/Donot-nodata.svg";
import { useUserType } from "../../contexts/UserTypeContext";
import { useAdminDarkMode } from "../../contexts/AdminDarkModeContext";
import { useUserTimezoneFormatter } from "../UserTimezoneDateFormatter/UserTimezoneDateFormatter";
import CalendarMonthRoundedIcon from "@mui/icons-material/CalendarMonthRounded";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DateCalendar } from "@mui/x-date-pickers/DateCalendar";
const OneOffContract = ({
  formik,
  isCalendarVisible,
  setIsCalendarVisible,
  dateFormat = "MM/DD/YYYY",
}) => {
  const formatDateWithUserTimezone = useUserTimezoneFormatter();
  const [duration, setDuration] = useState(
    formik?.values?.OneoffJob?.Duration || ""
  );
  const [value, setValue] = useState(formik?.values?.OneoffJob?.Frequency || 6);
  const [modelOpen, setModelOpen] = useState(false);
  const [selectedDay, setSelectedDay] = useState("");
  const [selectedDate, setSelectedDate] = useState(null);
  const [Repeats, setRepeats] = useState(
    formik?.values?.OneoffJob?.Repeats || ""
  );
  const [customFrequency, setCustomFrequency] = useState(
    formik?.values?.OneoffJob?.CustomFrequency || "1"
  );
  const [visitDates, setVisitDates] = useState([]);

  const toggleCalendarVisibility = () => {
    setIsCalendarVisible(!isCalendarVisible);
  };

  const isScheduleLetterChecked =
    formik?.values?.OneoffJob?.ScheduleLetter || false;

  const handleRepeatsChange = (e) => {
    const selectedValue = e.target.value;
    setRepeats(selectedValue);
    formik.setFieldValue("OneoffJob.Repeats", selectedValue);

    if (selectedValue === "Custom") {
      setModelOpen(true);
    } else {
      setModelOpen(false);
      setSelectedDay("");
      setSelectedDate(null);
      calculateTotalVisits();
    }
  };

  const handleScheduleLetterChange = (e) => {
    const checked = e.target.checked;
    formik.setFieldValue("OneoffJob.ScheduleLetter", checked);
    if (checked) {
      formik.setFieldValue("OneoffJob.Repeats", "");
      formik.setFieldValue("OneoffJob.StartDate", null);
      formik.setFieldValue("OneoffJob.EndDate", null);
      formik.setFieldValue("OneoffJob.StartTime", "");
      formik.setFieldValue("OneoffJob.EndTime", "");
      formik.setFieldValue("OneoffJob.TotalVisits", null);
    }
  };

  const calculateTotalVisits = () => {
    const startDate = formik?.values?.OneoffJob?.StartDate;
    const endDate = formik?.values?.OneoffJob?.EndDate;
    const repeats = formik?.values?.OneoffJob?.Repeats;

    if (!startDate || !endDate || !repeats) {
      formik.setFieldValue("OneoffJob.TotalVisits", null);
      return;
    }

    try {
      const start = moment(startDate);
      const end = moment(endDate);

      if (!start.isValid() || !end.isValid()) {
        formik.setFieldValue("OneoffJob.TotalVisits", null);
        return;
      }

      if (end.isBefore(start)) {
        formik.setFieldValue("OneoffJob.TotalVisits", null);
        return;
      }

      let totalVisits = 0;
      const frequency = parseInt(customFrequency, 10) || 1;

      if (repeats === "Daily") {
        totalVisits = Math?.floor(end.diff(start, "days") / frequency) + 1;
      } else if (repeats === "Weekly") {
        totalVisits = Math?.floor(end.diff(start, "weeks") / frequency) + 1;
      } else if (repeats === "Monthly") {
        totalVisits = Math?.floor(end.diff(start, "months") / frequency) + 1;
      } else if (repeats.startsWith("Weekly on")) {
        const targetDay = selectedDay || repeats.split("Weekly on ")[1];
        let current = moment(start);
        while (current.isSameOrBefore(end)) {
          if (current.format("dddd") === targetDay) {
            totalVisits++;
          }
          current.add(1, "day");
        }
      } else if (repeats.startsWith("Monthly on the")) {
        const targetDate = selectedDate
          ? moment(selectedDate).date()
          : parseInt(repeats.match(/(\d+)/)[0], 10);
        let current = moment(start).date(targetDate);
        if (current.isBefore(start)) current.add(1, "month");
        while (current.isSameOrBefore(end)) {
          if (current.isValid() && current.isSameOrAfter(start)) {
            totalVisits++;
          }
          current.add(frequency, "months");
        }
      } else if (repeats.startsWith("Every")) {
        if (repeats.includes("day(s)") || repeats.includes("Daily")) {
          totalVisits = Math?.floor(end.diff(start, "days") / frequency) + 1;
        } else if (repeats.includes("week(s)") || repeats.includes("Weekly")) {
          totalVisits = Math?.floor(end.diff(start, "weeks") / frequency) + 1;
        } else if (
          repeats.includes("month(s)") ||
          repeats.includes("Monthly")
        ) {
          totalVisits = Math?.floor(end.diff(start, "months") / frequency) + 1;
        } else if (
          repeats?.includes("year(s)") ||
          repeats?.includes("Yearly")
        ) {
          totalVisits = Math?.floor(end.diff(start, "years") / frequency) + 1;
        }
      }

      formik.setFieldValue(
        "OneoffJob.TotalVisits",
        totalVisits >= 0 ? totalVisits : null
      );
    } catch (error) {
      console.error("Error calculating total visits:", error);
      formik?.setFieldValue("OneoffJob.TotalVisits", null);
    }
  };

  const handleCustomOk = () => {
    if (!duration) {
      return;
    }
    if (duration === "Weekly" && !selectedDay) {
      return;
    }
    if (duration === "Monthly" && !selectedDate) {
      return;
    }
    if (!customFrequency || parseInt(customFrequency) < 1) {
      return;
    }

    let customText = "";
    if (duration === "Weekly" && selectedDay) {
      customText = `Weekly on ${selectedDay}`;
    } else if (duration === "Monthly" && selectedDate) {
      const date = moment(selectedDate).format("Do");
      customText = `Monthly on the ${date} of the month`;
    } else if (duration === "Daily") {
      customText = `Every ${customFrequency} day(s)`;
    } else if (duration === "Weekly") {
      customText = `Every ${customFrequency} week(s)`;
    } else if (duration === "Monthly") {
      customText = `Every ${customFrequency} month(s)`;
    } else if (duration === "Yearly") {
      customText = `Every ${customFrequency} year(s)`;
    }

    setRepeats(customText);
    formik?.setFieldValue("OneoffJob.Repeats", customText);
    formik?.setFieldValue("OneoffJob.CustomFrequency", customFrequency);
    formik?.setFieldValue("OneoffJob.Duration", duration);
    formik?.setFieldValue("OneoffJob.Frequency", value);

    calculateTotalVisits();
    setModelOpen(false);
  };

  const handleDurationChangeCustom = (event) => {
    setDuration(event?.target?.value);
    setSelectedDay("");
    setSelectedDate(null);
  };

  useEffect(() => {
    calculateTotalVisits();
  }, [
    formik?.values?.OneoffJob?.StartDate,
    formik?.values?.OneoffJob?.EndDate,
    Repeats,
    customFrequency,
    formik?.values?.OneoffJob?.TotalVisits,
  ]);

  return (
    <Col
      className="col-md-4 col-lg-12 col-sm-12 first-tab"
      md={4}
      lg={12}
      sm={12}
    >
      <TabContent
        activeTab={1}
        className="text-start my-3 mx-0"
        style={{ padding: "2px" }}
      >
        <TabPane tabId={1}>
          <Col sm="12" className="d-flex">
            <Card className="mx-0 border-blue-color" style={{ width: "100%"}}>
              <CardHeader
                style={{ display: "flex", justifyContent: "space-between" }}
                className="recurringSchedule_hideCalender"
              >
                <Typography className="calender_head heading-five text-blue-color">
                  One-off Contract Schedule
                </Typography> 
                <Typography className="btngotoright">
                  <BlueButton
                    className="btnhideFor"
                    style={{
                      padding: "0 14px 0 14px",
                      fontSize: "12px",
                      marginTop: 0,
                      height: "32px",
                      borderRadius: "2px",
                    }}
                    onClick={toggleCalendarVisibility}
                    label={
                      isCalendarVisible ? "Hide Calendar " : "Show Calendar"
                    }
                  />
                </Typography>
              </CardHeader>

              <CardBody
                className={isScheduleLetterChecked ? "blurred-fields" : ""}
              >
                <FormGroup style={{ marginBottom: "20px" }}>
                  <Label htmlFor="startDate">Start Date</Label>
                  <DatePicker
                    name="OneoffJob.StartDate"
                    className="ContrcatWidthDateFormat reccuringStartDate"
                    label="Start Date"
                    placeholder="Select Date"
                    disabled={isScheduleLetterChecked}
                    value={formik?.values?.OneoffJob?.StartDate || null}
                    minDate={dayjs().startOf('day')}
                    shouldDisableDate={(date) => {
                      if (!date) return false;
                      return date.isBefore(dayjs().startOf('day'), 'day');
                    }}
                    onChange={(e) => {
                      const value = e?.target?.value;
                      const startDate =
                        value && value !== null && value !== "" && dayjs(value).isValid()
                          ? value
                          : null;

                      formik.setFieldValue("OneoffJob.StartDate", startDate);
                      if (
                        formik?.values?.OneoffJob?.EndDate &&
                        startDate &&
                        new Date(startDate) >
                          new Date(formik?.values?.OneoffJob?.EndDate)
                      ) {
                        formik.setFieldValue("OneoffJob.EndDate", null);
                      }
                      calculateTotalVisits();
                    }}
                    onBlur={formik?.handleBlur}
                    format={dateFormat}
                    error={formik?.errors?.OneoffJob?.StartDate}
                    slotProps={{
                      textField: {
                        placeholder: formik?.values?.OneoffJob?.StartDate ? "" : "Select Date",
                        sx: {
                          "& .MuiInputLabel-root": {
                            "&:not(.MuiInputLabel-shrink):not(.Mui-focused)": {
                              transform: "translate(14px, 16px) scale(1)",
                            },
                          },
                        },
                      },
                    }}
                  />
                </FormGroup>

                <FormGroup style={{ marginBottom: "20px" }}>
                  <Label htmlFor="endDate">End Date</Label>
                  <DatePicker
                    name="OneoffJob.EndDate"
                    className="ContrcatWidthDateFormat reccuringStartDate"
                    label="End Date"
                    placeholder="Select Date"
                    disabled={isScheduleLetterChecked}
                    value={formik?.values?.OneoffJob?.EndDate || null}
                    minDate={formik?.values?.OneoffJob?.StartDate ? dayjs(formik?.values?.OneoffJob?.StartDate) : dayjs().startOf('day')}
                    shouldDisableDate={(date) => {
                      if (!date) return false;
                      const minDate = formik?.values?.OneoffJob?.StartDate 
                        ? dayjs(formik?.values?.OneoffJob?.StartDate) 
                        : dayjs().startOf('day');
                      return date.isBefore(minDate, 'day');
                    }}
                    onChange={(e) => {
                      const value = e?.target?.value;
                      const endDate =
                        value && value !== null && value !== "" && dayjs(value).isValid()
                          ? value
                          : null;

                      if (
                        formik?.values?.OneoffJob?.StartDate &&
                        endDate &&
                        new Date(endDate) >=
                          new Date(formik?.values?.OneoffJob?.StartDate)
                      ) {
                        formik.setFieldValue("OneoffJob.EndDate", endDate);
                        calculateTotalVisits();
                      } else {
                        formik.setFieldValue("OneoffJob.EndDate", null);
                        calculateTotalVisits();
                      }
                    }}
                    onBlur={formik?.handleBlur}
                    format={dateFormat}
                    error={formik?.errors?.OneoffJob?.EndDate}
                    slotProps={{
                      textField: {
                        placeholder: formik?.values?.OneoffJob?.EndDate ? "" : "Select Date",
                        sx: {
                          "& .MuiInputLabel-root": {
                            "&:not(.MuiInputLabel-shrink):not(.Mui-focused)": {
                              transform: "translate(14px, 16px) scale(1)",
                            },
                          },
                        },
                      },
                    }}
                  />
                </FormGroup>

                {/* <Grid
                  className="d-flex time-section mb-2"
                  style={{ width: "100%" }}
                >
                  <Col
                    className="col-6 border-blue-color"
                    style={{
                      borderBottomLeftRadius: "10px",
                      borderTopLeftRadius: "10px",
                      border: "1px solid rgba(6, 49, 100, 30%)",
                    }}
                  >
                    <Input
                      id="startTime"
                      type="time"
                      name="OneoffJob.StartTime"
                      onChange={(e) => {
                        const val = e.target.value;
                        formik.setFieldValue("OneoffJob.StartTime", val);
                        if (
                          formik?.values?.OneoffJob?.EndTime &&
                          val &&
                          val > formik?.values?.OneoffJob?.EndTime
                        ) {
                          formik.setFieldValue("OneoffJob.EndTime", val);
                        }
                      }}
                      value={formik?.values?.OneoffJob?.StartTime || ""}
                      disabled={isScheduleLetterChecked}
                      style={{
                        fontSize: "14px",
                        border: "none",
                        height: "40px",
                        borderBottomLeftRadius: "10px",
                        borderTopLeftRadius: "10px",
                        filter: isScheduleLetterChecked ? "blur(1px)" : "none",
                        marginBottom: 0,
                      }}
                      className="text-blue-color"
                    />
                  </Col>

                  <Col
                    className="col-6 border-blue-color"
                    style={{
                      borderBottomRightRadius: "10px",
                      borderTopRightRadius: "10px",
                      border: "1px solid rgba(6, 49, 100, 30%)",
                      borderLeft: "none",
                    }}
                  >
                    <Input
                      id="EndTime"
                      type="time"
                      name="OneoffJob.EndTime"
                      onChange={(e) => {
                        const val = e.target.value;
                        if (
                          formik?.values?.OneoffJob?.StartTime &&
                          val &&
                          val < formik?.values?.OneoffJob?.StartTime
                        ) {
                          formik.setFieldValue(
                            "OneoffJob.EndTime",
                            formik?.values?.OneoffJob?.StartTime
                          );
                        } else {
                          formik.setFieldValue("OneoffJob.EndTime", val);
                        }
                      }}
                      value={formik?.values?.OneoffJob?.EndTime || ""}
                      disabled={isScheduleLetterChecked}
                      style={{
                        fontSize: "14px",
                        border: "none",
                        height: "40px",
                        borderBottomRightRadius: "14px",
                        borderTopRightRadius: "14px",
                        filter: isScheduleLetterChecked ? "blur(1px)" : "none",
                      }}
                      className="text-blue-color"
                    />
                  </Col>
                </Grid> */}

                {/* <Label htmlFor="Repeats" className="mt-2 text-blue-color">
                  Repeats
                </Label> */}
                {/* <Input
                  type="select"
                  name="OneoffJob.Repeats"
                  className="text-blue-color border-blue-color"
                  onChange={handleRepeatsChange}
                  value={Repeats}
                  disabled={isScheduleLetterChecked}
                  style={{
                    fontSize: "14px",
                    border: "1px solid rgba(6, 49, 100, 30%)",
                    borderRadius: "10px",
                    height: "40px",
                    filter: isScheduleLetterChecked ? "blur(1px)" : "none",
                  }}
                >
                  <option value="">Repeat Frequency</option>
                  <option value="Daily">Daily</option>
                  <option value="Weekly">Weekly</option>
                  <option value="Monthly">Monthly</option>
                  <option value="Custom">Custom Schedule...</option>
                  {Repeats && Repeats.startsWith("Weekly on") && (
                    <option value={Repeats}>{Repeats}</option>
                  )}
                  {Repeats && Repeats.startsWith("Monthly on the") && (
                    <option value={Repeats}>{Repeats}</option>
                  )}
                  {Repeats && Repeats.startsWith("Every") && (
                    <option value={Repeats}>{Repeats}</option>
                  )}
                </Input> */}

                <Grid style={{ marginBottom: "20px" }}>
                  <FormGroup
                    className="my-3 mb-0 d-flex"
                    style={{
                      width: "fit-content",
                      flexDirection: "row",
                      gap: "10px",
                    }}
                  >
                    <Input
                      type="checkbox"
                      name="OneoffJob.ScheduleLetter"
                      id="scheduleLetter"
                      onChange={handleScheduleLetterChange}
                      checked={isScheduleLetterChecked}
                    />
                    <Label
                      htmlFor="scheduleLetter"
                      className="text-blue-color"
                      style={{
                        fontSize: "12px",
                        color: "rgba(6,49,100,0.7)",
                        fontWeight: "400",
                        marginTop: "5px",
                      }}
                    >
                      Schedule later
                    </Label>
                  </FormGroup>
                </Grid>

                <Grid className="d-flex mt-2" style={{ marginBottom: "20px" }}>
                  <Col
                    className="col-4"
                    style={{
                      borderRight: "0.5px solid rgba(6,49,100, 0.8)",
                    }}
                    xl={4}
                  >
                    <Typography
                      className="mb-0 text-blue-color"
                      color="rgba(6, 49, 100, 30%)"
                      style={{ fontSize: "12px" }}
                    >
                      First
                    </Typography>
                    <Typography
                      className="mb-0 text-blue-color"
                      color="rgba(6, 49, 100, 30%)"
                      style={{ fontSize: "12px" }}
                    >
                      {formik?.values?.OneoffJob?.StartDate
                        ? (() => {
                            // Get clean date format (strip time components if present)
                            let cleanDateFormat = dateFormat || "MM/DD/YYYY";
                            if (typeof cleanDateFormat === 'object' && cleanDateFormat?.Format) {
                              cleanDateFormat = cleanDateFormat.Format;
                            }
                            // Strip time components from date format string
                            cleanDateFormat = String(cleanDateFormat)
                              .replace(/\s*h{1,2}:mm:ss\s*[aApP][mM]\s*/gi, ' ')  // h:mm:ss A or hh:mm:ss A
                              .replace(/\s*H{1,2}:mm:ss\s*/gi, ' ')  // HH:mm:ss or H:mm:ss
                              .replace(/\s*h{1,2}:mm\s*[aApP][mM]\s*/gi, ' ')  // h:mm A or hh:mm A
                              .replace(/\s*H{1,2}:mm\s*/gi, ' ')  // HH:mm or H:mm
                              .replace(/\s*:ss\s*/gi, ' ')  // Standalone :ss pattern
                              .replace(/\s+[aApP][mM]?\s*$/gi, ' ')  // Trailing AM/PM
                              .replace(/\s+[aApP][mM]?\s+/gi, ' ')  // Standalone AM/PM in middle
                              .replace(/\s+/g, ' ')  // Clean up multiple spaces
                              .trim();
                            if (!cleanDateFormat || cleanDateFormat === '') {
                              cleanDateFormat = "MM/DD/YYYY";
                            }
                            
                            // Format date directly without timezone conversion - DatePicker already gives us local date
                            // Convert dateFormat to dayjs format
                            const dayjsFormat = cleanDateFormat
                              .replace(/MM/g, 'MM')
                              .replace(/DD/g, 'DD')
                              .replace(/YYYY/g, 'YYYY')
                              .replace(/YY/g, 'YY')
                              .replace(/-/g, '/'); // dayjs uses / for separators
                            
                            return dayjs(formik?.values?.OneoffJob?.StartDate).format(cleanDateFormat);
                          })()
                        : "-"}
                    </Typography>
                  </Col>
                  <Col
                    className="col-4 mx-1"
                    style={{
                      borderRight: "0.5px solid rgba(6,49,100, 0.8)",
                    }}
                    xl={4}
                  >
                    <Typography
                      className="mb-0 text-blue-color"
                      color="rgba(6, 49, 100, 30%)"
                      style={{ fontSize: "12px" }}
                    >
                      Last
                    </Typography>
                    <Typography
                      className="mb-0 text-blue-color"
                      color="rgba(6, 49, 100, 30%)"
                      style={{ fontSize: "12px" }}
                    >
                      {formik?.values?.OneoffJob?.EndDate
                        ? (() => {
                            // Get clean date format (strip time components if present)
                            let cleanDateFormat = dateFormat || "MM/DD/YYYY";
                            if (typeof cleanDateFormat === 'object' && cleanDateFormat?.Format) {
                              cleanDateFormat = cleanDateFormat.Format;
                            }
                            // Strip time components from date format string
                            cleanDateFormat = String(cleanDateFormat)
                              .replace(/\s*h{1,2}:mm:ss\s*[aApP][mM]\s*/gi, ' ')  // h:mm:ss A or hh:mm:ss A
                              .replace(/\s*H{1,2}:mm:ss\s*/gi, ' ')  // HH:mm:ss or H:mm:ss
                              .replace(/\s*h{1,2}:mm\s*[aApP][mM]\s*/gi, ' ')  // h:mm A or hh:mm A
                              .replace(/\s*H{1,2}:mm\s*/gi, ' ')  // HH:mm or H:mm
                              .replace(/\s*:ss\s*/gi, ' ')  // Standalone :ss pattern
                              .replace(/\s+[aApP][mM]?\s*$/gi, ' ')  // Trailing AM/PM
                              .replace(/\s+[aApP][mM]?\s+/gi, ' ')  // Standalone AM/PM in middle
                              .replace(/\s+/g, ' ')  // Clean up multiple spaces
                              .trim();
                            if (!cleanDateFormat || cleanDateFormat === '') {
                              cleanDateFormat = "MM/DD/YYYY";
                            }
                            
                            // Format date directly without timezone conversion - DatePicker already gives us local date
                            return dayjs(formik?.values?.OneoffJob?.EndDate).format(cleanDateFormat);
                          })()
                        : "-"}
                    </Typography>
                  </Col>
                  <Col className="col-4 mx-1" xl={4}>
                    <Typography
                      className="mb-0 text-blue-color"
                      color="rgba(6, 49, 100, 30%)"
                      style={{ fontSize: "12px" }}
                    >
                      Total
                    </Typography>
                    <Typography
                      className="mb-0 text-blue-color"
                      color="rgba(6, 49, 100, 30%)"
                      style={{ fontSize: "12px" }}
                    >
                      {formik?.values?.OneoffJob?.TotalVisits || "-"}
                    </Typography>
                  </Col>
                </Grid>
              </CardBody>
            </Card>
          </Col>
        </TabPane>
      </TabContent>
      <Dialog open={modelOpen} onClose={() => setModelOpen(false)}>
        <DialogTitle className="borerBommoModel">
          <Grid className="d-flex justify-content-between">
            <Typography style={{ fontWeight: 600 }}>Custom Repeat</Typography>
            <Grid onClick={() => setModelOpen(false)}>
              <CancelIcon />
            </Grid>
          </Grid>
        </DialogTitle>
        <DialogContent>
          <Grid className="mt-4">
            <Grid
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Typography
                className="text-blue-color"
                style={{ fontWeight: 600 }}
              >
                Frequency :
              </Typography>
              <Select
                value={duration || ""}
                onChange={handleDurationChangeCustom}
                style={{ borderRadius: "5px", width: "80%", height: "40px" }}
                className="text-blue-color border-blue-color durationSecondBox"
                displayEmpty
              >
                <MenuItem value="" disabled>
                  Select Duration
                </MenuItem>
                <MenuItem className="text-blue-color" value="Daily">
                  Daily
                </MenuItem>
                <MenuItem className="text-blue-color" value="Weekly">
                  Weekly
                </MenuItem>
                <MenuItem className="text-blue-color" value="Monthly">
                  Monthly
                </MenuItem>
                <MenuItem className="text-blue-color" value="Yearly">
                  Yearly
                </MenuItem>
              </Select>
            </Grid>

            <Grid
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
              className="mt-4"
            >
              <Typography
                className="text-blue-color"
                style={{ fontWeight: 600 }}
              >
                Every
              </Typography>
              <Grid style={{ width: "80%" }} className="duration-custom">
                <InputText
                  name="Repeat Every"
                  id="Repeat Every"
                  placeholder="Enter Repeat Every"
                  label="Repeat Every"
                  type="number"
                  value={customFrequency}
                  onChange={(e) => setCustomFrequency(e.target.value)}
                  className="text-blue-color w-100"
                  fieldHeight="40px"
                  inputProps={{ min: 1, style: { padding: "5px 8px" } }}
                  endAdornment={
                    duration ? (
                      <InputAdornment position="end">
                        <Typography
                          className="text-blue-color"
                          style={{ fontWeight: 400, whiteSpace: "nowrap" }}
                        >
                          {duration === "Daily"
                            ? "day(s)"
                            : duration === "Weekly"
                            ? "week(s)"
                            : duration === "Monthly"
                            ? "month(s)"
                            : duration === "Yearly"
                            ? "year(s)"
                            : ""}
                        </Typography>
                      </InputAdornment>
                    ) : null
                  }
                />
              </Grid>
            </Grid>

            {duration === "Weekly" && (
              <Grid
                className="mt-3"
                style={{ width: "80%", marginLeft: "auto" }}
              >
                <Select
                  value={selectedDay}
                  onChange={(e) => setSelectedDay(e.target.value)}
                  style={{ borderRadius: "5px", width: "100%", height: "40px" }}
                  className="text-blue-color border-blue-color durationSecondBox"
                  displayEmpty
                >
                  <MenuItem value="" disabled>
                    Select a Day
                  </MenuItem>
                  <MenuItem value="Sunday" className="text-blue-color">
                    Sunday
                  </MenuItem>
                  <MenuItem value="Monday" className="text-blue-color">
                    Monday
                  </MenuItem>
                  <MenuItem value="Tuesday" className="text-blue-color">
                    Tuesday
                  </MenuItem>
                  <MenuItem value="Wednesday" className="text-blue-color">
                    Wednesday
                  </MenuItem>
                  <MenuItem value="Thursday" className="text-blue-color">
                    Thursday
                  </MenuItem>
                  <MenuItem value="Friday" className="text-blue-color">
                    Friday
                  </MenuItem>
                  <MenuItem value="Saturday" className="text-blue-color">
                    Saturday
                  </MenuItem>
                </Select>
              </Grid>
            )}

            {duration === "Monthly" && (
              <Grid
                className="mt-4"
                style={{ width: "80%", marginLeft: "auto" }}
              >
                <DatePicker
                  name="selectedDate"
                  label="Select Date"
                  value={selectedDate || ""}
                  className="text-blue-color border-blue-color"
                  onChange={(e) => setSelectedDate(e.target.value)}
                  format={dateFormat}
                />
              </Grid>
            )}
            {["Daily", "Weekly", "Monthly", "Yearly"].includes(duration) && (
              <Grid
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  width: "100%",
                }}
                className="mt-4"
              >
                <Typography
                  className="text-blue-color"
                  style={{ fontWeight: 600, whiteSpace: "nowrap" }}
                >
                  Summary :
                </Typography>
                <Typography
                  className="text-blue-color"
                  style={{ fontWeight: 600, whiteSpace: "nowrap" }}
                >
                  {duration === "Daily"
                    ? `Every ${customFrequency} day(s)`
                    : duration === "Weekly"
                    ? `Weekly on ${
                        selectedDay || "[day not selected]"
                      } every ${customFrequency} week(s)`
                    : duration === "Monthly"
                    ? selectedDate
                      ? `Monthly on the ${moment(selectedDate).format(
                          "Do"
                        )} every ${customFrequency} month(s)`
                      : `Monthly every ${customFrequency} month(s)`
                    : `Yearly every ${customFrequency} year(s)`}
                </Typography>
              </Grid>
            )}
          </Grid>
        </DialogContent>
        <DialogActions>
          <WhiteButton
            className="planCancelBtn"
            style={{ marginTop: "3%" }}
            onClick={() => {
              setModelOpen(false);
              setSelectedDay("");
              setSelectedDate(null);
              if (Repeats === "Custom") {
                setRepeats("");
                formik.setFieldValue("OneoffJob.Repeats", "");
                formik.setFieldValue("OneoffJob.TotalVisits", null);
              }
            }}
            label="Cancel"
          />

          <BlueButton
            className="mt-3 bg-button-blue-color"
            type="button"
            style={{ color: "white", height: "41px" }}
            onClick={handleCustomOk}
            label="OK"
          />
        </DialogActions>
      </Dialog>
    </Col>
  );
};

const RecurringContract = ({
  formik,
  isCalendarVisible,
  setIsCalendarVisible,
  dateFormat = "MM/DD/YYYY",
}) => {
  const formatDateWithUserTimezone = useUserTimezoneFormatter();
  const [duration, setDuration] = useState(
    formik?.values?.RecuringJob?.Duration || ""
  );
  const [value, setValue] = useState(
    formik?.values?.RecuringJob?.Frequency || 1
  );
  const [lastDate, setLastDate] = useState("");
  const [isCardVisible, setIsCardVisible] = useState(true);
  const [modelOpen, setModelOpen] = useState(false);
  const [selectedDay, setSelectedDay] = useState("");
  const [selectedDate, setSelectedDate] = useState(null);
  const [Repeats, setRepeats] = useState(
    formik?.values?.RecuringJob?.Repeats || ""
  );
  const [customFrequency, setCustomFrequency] = useState(
    formik?.values?.RecuringJob?.CustomFrequency || "1"
  );
  const [visitDates, setVisitDates] = useState([]);
  const [isInitialized, setIsInitialized] = useState(false);
  const [modalDuration, setModalDuration] = useState("");

  useEffect(() => {
    if (!formik?.values?.RecuringJob?.StartDate) {
      const currentDate = dayjs().toISOString();
      formik?.setFieldValue("RecuringJob.StartDate", currentDate);
    }
  }, []);

  useEffect(() => {
    if (
      formik?.values?.RecuringJob &&
      Object.keys(formik?.values?.RecuringJob).length > 0 &&
      !isInitialized
    ) {
      if (formik?.values?.RecuringJob?.Duration) {
        setDuration(formik?.values?.RecuringJob?.Duration);
      }

      if (formik?.values?.RecuringJob?.Frequency) {
        setValue(formik?.values?.RecuringJob?.Frequency);
      }

      if (formik?.values?.RecuringJob?.CustomFrequency) {
        setCustomFrequency(formik?.values?.RecuringJob?.CustomFrequency);
      }

      if (formik?.values?.RecuringJob?.Repeats) {
        const repeatsValue = formik?.values?.RecuringJob?.Repeats;
        setRepeats(repeatsValue);

        if (repeatsValue.startsWith("Every")) {
          const match = repeatsValue.match(
            /Every (\d+) (day|week|month|year)/i
          );
          if (match) {
            setCustomFrequency(match[1]);
          }
        } else if (repeatsValue.startsWith("Weekly")) {
          const day = repeatsValue.split("Weekly on ")[1];
          if (day) setSelectedDay(day);
        } else if (repeatsValue.startsWith("Monthly")) {
          const dateMatch = repeatsValue.match(/the (\d+)/);
          if (dateMatch) {
            const dateNum = Number.parseInt(dateMatch[1], 10);
            setSelectedDate(
              moment(formik?.values?.RecuringJob?.StartDate)
                .date(dateNum)
                .format("YYYY-MM-DD")
            );
          }
        }
      }

      setIsInitialized(true);
    }
  }, [formik?.values?.RecuringJob, isInitialized]);

  useEffect(() => {
    if (
      isInitialized &&
      formik?.values?.RecuringJob?.StartDate &&
      duration &&
      value
    ) {
      const calculatedEndDate = calculateFutureDate(
        formik?.values?.RecuringJob?.StartDate,
        duration,
        value
      );
      if (calculatedEndDate) {
        setLastDate(calculatedEndDate);
        formik?.setFieldValue("RecuringJob.EndDate", calculatedEndDate);
      }
    }
  }, [value, duration, formik?.values?.RecuringJob?.StartDate, isInitialized]);

  useEffect(() => {
    if (
      isInitialized &&
      lastDate &&
      formik?.values?.RecuringJob?.StartDate &&
      Repeats &&
      customFrequency
    ) {
      const visits = calculateTotalVisits(
        formik?.values?.RecuringJob?.StartDate,
        lastDate,
        Repeats,
        customFrequency
      );

      formik?.setFieldValue("RecuringJob.TotalVisits", visits);

      const dates = generateVisitDates(
        formik?.values?.RecuringJob?.StartDate,
        lastDate,
        Repeats,
        customFrequency,
        selectedDay,
        selectedDate
      );
      setVisitDates(dates);
      formik?.setFieldValue("RecuringJob.Visits", dates);
      postVisits(dates);
    }
  }, [
    lastDate,
    formik?.values?.RecuringJob?.StartDate,
    Repeats,
    customFrequency,
    selectedDay,
    selectedDate,
    isInitialized,
    formik?.values?.RecuringJob?.TotalVisits,
  ]);

  useEffect(() => {
    if (
      isInitialized &&
      formik?.values?.RecuringJob?.StartDate &&
      formik?.values?.RecuringJob?.EndDate &&
      Repeats &&
      customFrequency &&
      duration
    ) {
      const totalVisits = calculateTotalVisits(
        formik?.values?.RecuringJob?.StartDate,
        formik?.values?.RecuringJob?.EndDate,
        Repeats,
        customFrequency
      );

      if (totalVisits >= 0) {
        formik?.setFieldValue("RecuringJob.TotalVisits", totalVisits);
      }
    }
  }, [
    isInitialized,
    formik?.values?.RecuringJob?.StartDate,
    formik?.values?.RecuringJob?.EndDate,
    Repeats,
    customFrequency,
    duration,
    formik?.values?.RecuringJob?.TotalVisits,
  ]);

  useEffect(() => {
    if (
      isInitialized &&
      formik?.values?.RecuringJob?.StartDate &&
      lastDate &&
      Repeats &&
      customFrequency &&
      duration
    ) {
      if (!Repeats || Repeats === "") {
        let defaultRepeats = "";
        switch (duration) {
          case "day(s)":
            defaultRepeats = "Every 1 day(s)";
            break;
          case "week(s)":
            defaultRepeats = "Every 1 week(s)";
            break;
          case "month(s)":
            defaultRepeats = "Every 1 month(s)";
            break;
          case "year(s)":
            defaultRepeats = "Every 1 year(s)";
            break;
          default:
            defaultRepeats = `Every ${customFrequency} ${duration}`;
        }

        if (defaultRepeats) {
          setRepeats(defaultRepeats);
          formik?.setFieldValue("RecuringJob.Repeats", defaultRepeats);

          const editModeVisits = calculateTotalVisits(
            formik?.values?.RecuringJob?.StartDate,
            lastDate,
            defaultRepeats,
            customFrequency
          );

          if (editModeVisits >= 0) {
            formik?.setFieldValue("RecuringJob.TotalVisits", editModeVisits);
          }
        }
      }
    }
  }, [
    isInitialized,
    formik?.values?.RecuringJob?.StartDate,
    lastDate,
    Repeats,
    customFrequency,
    duration,
    formik?.values?.RecuringJob?.TotalVisits,
  ]);

  const handleStartTimeChange = (e) => {
    const StartTime = e?.target?.value;
    formik?.setFieldValue("RecuringJob.StartTime", StartTime ?? "");

    if (StartTime && !formik?.values?.RecuringJob?.EndTime) {
      const startTimeObj = new Date(`2000-01-01T${StartTime}`);
      const endTimeObj = new Date(startTimeObj.getTime() + 60 * 60 * 1000);
      const endTimeString = endTimeObj.toTimeString().slice(0, 5);
      formik?.setFieldValue("RecuringJob.EndTime", endTimeString);
    }

    if (
      formik?.values?.RecuringJob?.EndTime &&
      StartTime > formik?.values?.RecuringJob?.EndTime
    ) {
      formik?.setFieldValue("RecuringJob.EndTime", "");
    }
  };

  const toggleCalendarVisibility = () => {
    setIsCalendarVisible(!isCalendarVisible);
    setIsCardVisible(!isCardVisible);
  };

  const handleEndTimeChange = (e) => {
    const endTime = e?.target?.value;
    formik?.setFieldValue("RecuringJob.EndTime", endTime ?? "");

    if (
      formik?.values?.RecuringJob?.StartTime &&
      endTime < formik?.values?.RecuringJob?.StartTime
    ) {
      formik?.setFieldValue(
        "RecuringJob.EndTime",
        formik?.values?.RecuringJob?.StartTime
      );
    }
  };

  const handleDurationChange = (e) => {
    try {
      const newDuration = e?.target?.value;
      if (!newDuration) return;

      setDuration(newDuration);
      formik?.setFieldValue("RecuringJob.Duration", newDuration);

      const startDate = formik?.values?.RecuringJob?.StartDate;
      if (startDate) {
        const endDate = calculateFutureDate(startDate, newDuration, value);
        if (endDate) {
          setLastDate(endDate);
          formik?.setFieldValue("RecuringJob.EndDate", endDate);

          if (Repeats) {
            const totalVisits = calculateTotalVisits(
              startDate,
              endDate,
              Repeats,
              customFrequency
            );
            const visitDates = generateVisitDates(
              startDate,
              endDate,
              Repeats,
              customFrequency,
              selectedDay,
              selectedDate
            );

            formik?.setFieldValue("RecuringJob.TotalVisits", totalVisits);
            formik?.setFieldValue("RecuringJob.Visits", visitDates);
          }
        }
      }
    } catch (error) {
      console.error("Error handling duration change:", error);
    }
  };

  const handleValueChange = (e) => {
    const newValue = Number.parseInt(e?.target?.value) || 1;
    setValue(newValue);
    formik?.setFieldValue("RecuringJob.Frequency", newValue);
  };

  const calculateFutureDate = (startDate, duration, num) => {
    if (num && duration && startDate && moment(startDate).isValid()) {
      const durationNumber = Number.parseInt(num, 10);
      let futureDate;

      switch (duration) {
        case "Daily":
        case "day(s)":
          futureDate = moment(startDate).add(durationNumber - 1, "days");
          break;
        case "Weekly":
        case "week(s)":
          futureDate = moment(startDate)
            .add(durationNumber, "weeks")
            .subtract(1, "days");
          break;
        case "Monthly":
        case "month(s)":
          futureDate = moment(startDate)
            .add(durationNumber, "months")
            .subtract(1, "days");
          break;
        case "Yearly":
        case "year(s)":
          futureDate = moment(startDate)
            .add(durationNumber, "years")
            .subtract(1, "days");
          break;
        default:
          futureDate = moment(startDate);
      }

      const formattedDate = futureDate.format("YYYY-MM-DD");
      return formattedDate;
    } else {
      return "";
    }
  };

  const calculateTotalVisits = (startDate, endDate, Repeats, customFreq) => {
    if (!startDate || !endDate || !Repeats || !customFreq) {
      return 0;
    }

    try {
      const start = moment(startDate);
      const end = moment(endDate);
      const frequency = Number.parseInt(customFreq, 10) || 1;

      if (!start.isValid() || !end.isValid()) {
        return 0;
      }

      if (end.isBefore(start)) {
        return 0;
      }

      let totalVisits = 0;

      if (Repeats.startsWith("Weekly on")) {
        const weeksDiff = end.diff(start, "weeks");
        totalVisits = Math?.floor(weeksDiff / frequency) + 1;
      } else if (Repeats.startsWith("Every 2 Weeks on")) {
        const weeksDiff = end.diff(start, "weeks");
        totalVisits = Math?.floor(weeksDiff / 2) + 1;
      } else if (Repeats.startsWith("Monthly on the")) {
        const monthsDiff = end.diff(start, "months");
        totalVisits = Math?.floor(monthsDiff / frequency) + 1;
      } else if (
        Repeats.startsWith("Every") &&
        (Repeats.includes("day(s)") || Repeats.includes("Daily"))
      ) {
        const daysDiff = end.diff(start, "days");
        totalVisits = Math?.floor(daysDiff / frequency) + 1;
      } else if (
        Repeats.startsWith("Every") &&
        (Repeats.includes("week(s)") || Repeats.includes("Weekly"))
      ) {
        const weeksDiff = end.diff(start, "weeks");
        totalVisits = Math?.floor(weeksDiff / frequency) + 1;
      } else if (
        Repeats.startsWith("Every") &&
        (Repeats.includes("month(s)") || Repeats.includes("Monthly"))
      ) {
        const monthsDiff = end.diff(start, "months");
        totalVisits = Math?.floor(monthsDiff / frequency) + 1;
      } else if (
        Repeats.startsWith("Every") &&
        (Repeats.includes("year(s)") || Repeats.includes("Yearly"))
      ) {
        const yearsDiff = end.diff(start, "years");
        totalVisits = Math?.floor(yearsDiff / frequency) + 1;
      } else {
        return 0;
      }

      return totalVisits >= 0 ? totalVisits : 0;
    } catch (error) {
      console.error("Error calculating total visits:", error);
      return 0;
    }
  };

  const generateVisitDates = (
    startDate,
    lastDate,
    Repeats,
    customFreq,
    selectedDay,
    selectedDate
  ) => {
    if (!startDate || !lastDate || !Repeats) {
      return [];
    }

    const start = moment(startDate);
    const end = moment(lastDate);
    const frequency = Number.parseInt(customFreq, 10) || 1;
    const dates = [];

    if (Repeats.startsWith("Weekly on")) {
      const targetDay = selectedDay || Repeats.split("Weekly on ")[1];
      const current = moment(start);
      while (current.isSameOrBefore(end)) {
        if (current.format("dddd") === targetDay) {
          dates.push(current.format("YYYY-MM-DD"));
          current.add(frequency, "weeks");
        } else {
          current.add(1, "day");
        }
      }
    } else if (Repeats.startsWith("Every 2 Weeks on")) {
      const targetDay = Repeats.split("Every 2 Weeks on ")[1];
      const current = moment(start);
      while (current.isSameOrBefore(end)) {
        if (current.format("dddd") === targetDay) {
          dates.push(current.format("YYYY-MM-DD"));
          current.add(2, "weeks");
        } else {
          current.add(1, "day");
        }
      }
    } else if (Repeats.startsWith("Monthly on the")) {
      const targetDate = selectedDate
        ? moment(selectedDate).date()
        : Number.parseInt(Repeats.match(/(\d+)/)[0], 10);
      const current = moment(start).date(targetDate);
      if (current.isBefore(start)) current.add(1, "month");
      while (current.isSameOrBefore(end)) {
        if (current.isValid() && current.isSameOrAfter(start)) {
          dates.push(current.format("YYYY-MM-DD"));
        }
        current.add(frequency, "months");
      }
    } else if (
      Repeats.startsWith("Every") &&
      (Repeats.includes("day(s)") || Repeats.includes("Daily"))
    ) {
      const current = moment(start);
      while (current.isSameOrBefore(end)) {
        dates.push(current.format("YYYY-MM-DD"));
        current.add(frequency, "days");
      }
    } else if (
      Repeats.startsWith("Every") &&
      (Repeats.includes("week(s)") || Repeats.includes("Weekly"))
    ) {
      const current = moment(start);
      while (current.isSameOrBefore(end)) {
        dates.push(current.format("YYYY-MM-DD"));
        current.add(frequency, "weeks");
      }
    } else if (
      Repeats.startsWith("Every") &&
      (Repeats.includes("month(s)") || Repeats.includes("Monthly"))
    ) {
      const current = moment(start);
      while (current.isSameOrBefore(end)) {
        dates.push(current.format("YYYY-MM-DD"));
        current.add(frequency, "months");
      }
    } else if (
      Repeats.startsWith("Every") &&
      (Repeats.includes("year(s)") || Repeats.includes("Yearly"))
    ) {
      const current = moment(start);
      while (current.isSameOrBefore(end)) {
        dates.push(current.format("YYYY-MM-DD"));
        current.add(frequency, "years");
      }
    } else {
      return [];
    }

    return dates;
  };

  const postVisits = (visitDates) => {};

  const handleRepeatChange = (e) => {
    const selectedValue = e?.target?.value;
    setRepeats(selectedValue);
    formik?.setFieldValue("RecuringJob.Repeats", selectedValue);

    if (selectedValue === "Custom") {
      setModalDuration("");
      setSelectedDay("");
      setSelectedDate(null);
      setCustomFrequency("1");
      setModelOpen(true);
    } else {
      setModelOpen(false);
      setSelectedDay("");
      setSelectedDate(null);
    }
  };

  const handleCustomOk = () => {
    if (!modalDuration) {
      return;
    }
    if (modalDuration === "week(s)" && !selectedDay) {
      return;
    }
    if (modalDuration === "month(s)" && !selectedDate) {
      return;
    }
    if (!customFrequency || Number.parseInt(customFrequency) < 1) {
      return;
    }

    let customText = "";
    if (modalDuration === "week(s)" && selectedDay) {
      customText = `Weekly on ${selectedDay}`;
    } else if (modalDuration === "month(s)" && selectedDate) {
      const date = moment(selectedDate).format("Do");
      customText = `Monthly on the ${date} of the month`;
    } else if (modalDuration === "day(s)") {
      customText = `Every ${customFrequency} day(s)`;
    } else if (modalDuration === "week(s)") {
      customText = `Every ${customFrequency} week(s)`;
    } else if (modalDuration === "month(s)") {
      customText = `Every ${customFrequency} month(s)`;
    } else if (modalDuration === "year(s)") {
      customText = `Every ${customFrequency} year(s)`;
    }

    setDuration(modalDuration);
    setRepeats(customText);

    formik.setFieldValue("RecuringJob.Repeats", customText);
    formik.setFieldValue("RecuringJob.CustomFrequency", customFrequency);
    formik.setFieldValue("RecuringJob.Duration", modalDuration);
    formik.setFieldValue("RecuringJob.Frequency", value);

    const startDate = formik?.values?.RecuringJob?.StartDate;
    if (startDate) {
      const endDate = calculateFutureDate(startDate, modalDuration, value);
      if (endDate) {
        setLastDate(endDate);
        formik?.setFieldValue("RecuringJob.EndDate", endDate);

        const totalVisits = calculateTotalVisits(
          startDate,
          endDate,
          customText,
          customFrequency
        );
        const visitDates = generateVisitDates(
          startDate,
          endDate,
          customText,
          customFrequency,
          selectedDay,
          selectedDate
        );

        formik?.setFieldValue("RecuringJob.TotalVisits", totalVisits);
        formik?.setFieldValue("RecuringJob.Visits", visitDates);
        setVisitDates(visitDates);
      }
    }

    setModelOpen(false);
  };

  const handleDurationChangeCustom = (event) => {
    const selectedDuration = event?.target?.value;
    setModalDuration(selectedDuration);
    setSelectedDay("");
    setSelectedDate(null);
  };

  return (
    <Col
      className="col-md-4 col-lg-12 col-sm-12 first-tab mb-2"
      md={4}
      lg={12}
      sm={12}
    >
      <Card className="p-0 border-blue-color">
        <CardHeader
          style={{ display: "flex", justifyContent: "space-between" }}
          className="recurringSchedule_hideCalender"
        >
          <Typography className="calender_head heading-five text-blue-color">
            Recurring schedule
          </Typography>
          <BlueButton
            className="bg-button-blue-color"
            style={{
              padding: "0 14px 0 14px",
              fontSize: "12px",
              marginTop: 0,
              height: "32px",
              borderRadius: "2px",
            }}
            onClick={toggleCalendarVisibility}
            label={isCalendarVisible ? "Hide Calendar" : "Show Calendar"}
          />
        </CardHeader>

        <CardBody>
          <FormGroup>
            <Label htmlFor="startDate">Start Date</Label>
            <DatePicker
              name="RecuringJob.StartDate"
              className="ContrcatWidthDateFormat reccuringStartDate"
              label={undefined}
              placeholder="Select date"
              value={formik?.values?.RecuringJob?.StartDate}
              minDate={dayjs().startOf('day')}
              shouldDisableDate={(date) => {
                if (!date) return false;
                return date.isBefore(dayjs().startOf('day'), 'day');
              }}
              onChange={(e) => {
                const startDate = e.target.value;
                formik?.setFieldValue("RecuringJob.StartDate", startDate);
                if (
                  formik?.values?.RecuringJob?.EndDate &&
                  new Date(startDate) >
                    new Date(formik?.values?.RecuringJob?.EndDate)
                ) {
                  formik?.setFieldValue("RecuringJob.EndDate", "");
                }
              }}
              onBlur={formik?.handleBlur}
              format={dateFormat}
              error={formik?.errors?.RecuringJob?.StartDate}
            />
          </FormGroup>

          <Label htmlFor="timeRange" className="mt-2">
            Start Time & End Time
          </Label>
          <Grid
            container
            spacing={1.5}
            className="startEnd_contractTable"
            sx={{ alignItems: "stretch", mt: 0.5 }}
          >
            <Grid
              sx={{ minWidth: 0 }}
              size={{
                xs: 12,
                sm: 6
              }}>
              <InputText
                id="startTime"
                type="time"
                name="RecuringJob.StartTime"
                label=""
                ariaLabel="Start time"
                fieldHeight="44px"
                fullWidth
                className="text-blue-color"
                value={formik?.values?.RecuringJob?.StartTime || ""}
                onChange={handleStartTimeChange}
              />
            </Grid>
            <Grid
              sx={{ minWidth: 0 }}
              size={{
                xs: 12,
                sm: 6
              }}>
              <InputText
                id="endTime"
                type="time"
                name="RecuringJob.EndTime"
                label=""
                ariaLabel="End time"
                fieldHeight="44px"
                fullWidth
                className="text-blue-color"
                value={formik?.values?.RecuringJob?.EndTime || ""}
                onChange={handleEndTimeChange}
              />
            </Grid>
          </Grid>
          <FormGroup>
            <Label htmlFor="Repeats" className="mt-2">
              Repeats
            </Label>
            <InputText
              select
              SelectProps={{ displayEmpty: true }}
              name="RecuringJob.Repeats"
              label=""
              ariaLabel="Repeats schedule"
              fieldHeight="44px"
              fullWidth
              className="text-blue-color"
              value={Repeats ?? ""}
              onChange={handleRepeatChange}
            >
              <MenuItem value="">
                As needed - we won&apos;t prompt you
              </MenuItem>
              <MenuItem
                value={`Weekly on ${moment(
                  formik?.values?.RecuringJob?.StartDate
                ).format("dddd")}`}
              >
                Weekly on{" "}
                {moment(formik?.values?.RecuringJob?.StartDate).format("dddd")}
              </MenuItem>
              <MenuItem
                value={`Every 2 Weeks on ${moment(
                  formik?.values?.RecuringJob?.StartDate
                ).format("dddd")}`}
              >
                Every 2 Weeks on{" "}
                {moment(formik?.values?.RecuringJob?.StartDate).format("dddd")}
              </MenuItem>
              <MenuItem
                value={`Monthly on the ${moment(
                  formik?.values?.RecuringJob?.StartDate
                ).format("Do")} of the month`}
              >
                Monthly on the{" "}
                {moment(formik?.values?.RecuringJob?.StartDate).format("Do")} of
                the month
              </MenuItem>
              <MenuItem value="Custom">Custom Schedule...</MenuItem>
              {Repeats &&
                Repeats.startsWith("Weekly on") &&
                Repeats !==
                  `Weekly on ${moment(
                    formik?.values?.RecuringJob?.StartDate
                  ).format("dddd")}` && (
                  <MenuItem value={Repeats}>{Repeats}</MenuItem>
                )}
              {Repeats &&
                Repeats.startsWith("Monthly on the") &&
                Repeats !==
                  `Monthly on the ${moment(
                    formik?.values?.RecuringJob?.StartDate
                  ).format("Do")} of the month` && (
                  <MenuItem value={Repeats}>{Repeats}</MenuItem>
                )}
              {Repeats && Repeats.startsWith("Every") && (
                <MenuItem value={Repeats}>{Repeats}</MenuItem>
              )}
            </InputText>
          </FormGroup>

          <FormGroup>
            <Label htmlFor="duration" className="mt-2">
              Duration
            </Label>
            <Grid
              container
              spacing={1.5}
              direction={{ xs: "column", sm: "row" }}
              className="contractDurationInputBox recurring-duration-row"
              sx={{
                width: "100%",
                maxWidth: "100%",
                alignItems: "stretch",
              }}
            >
              <Grid
                sx={{ minWidth: 0 }}
                size={{
                  xs: 12,
                  sm: 3,
                  md: 3
                }}>
                <InputText
                  ariaLabel="Duration amount"
                  type="number"
                  label=""
                  name="RecuringJob.Frequency"
                  value={value === "" || value == null ? "" : String(value)}
                  onChange={handleValueChange}
                  inputProps={{ min: 1 }}
                  className="text-blue-color durationFIrstBox"
                  fieldHeight="44px"
                  fullWidth
                />
              </Grid>
              <Grid
                sx={{ minWidth: 0 }}
                size={{
                  xs: 12,
                  sm: 9,
                  md: 9
                }}>
                <InputText
                  select
                  SelectProps={{ native: true }}
                  label=""
                  name="RecuringJob.Duration"
                  ariaLabel="Duration unit"
                  fieldHeight="44px"
                  fullWidth
                  className="text-blue-color durationSecondBox recurring-duration-unit-select"
                  value={duration || ""}
                  onChange={handleDurationChange}
                >
                  <option value="" disabled>
                    Select duration
                  </option>
                  <option value="day(s)">day(s)</option>
                  <option value="week(s)">week(s)</option>
                  <option value="month(s)">month(s)</option>
                  <option value="year(s)">year(s)</option>
                </InputText>
              </Grid>
            </Grid>
          </FormGroup>
          <Grid className="d-flex mt-2">
            <Col
              className="col-4"
              style={{
                borderRight: "0.5px solid rgba(6,49,100, 0.8)",
              }}
              xl={4}
            >
              <Typography
                className="mb-0 text-blue-color"
                color="rgba(6, 49, 100, 30%)"
                style={{ fontSize: "12px" }}
              >
                First
              </Typography>
              <Typography
                className="mb-0 text-blue-color"
                color="rgba(6, 49, 100, 30%)"
                style={{ fontSize: "12px" }}
              >
                {formik?.values?.RecuringJob?.StartDate
                  ? (() => {
                      // Get clean date format (strip time components if present)
                      let cleanDateFormat = dateFormat || "MM/DD/YYYY";
                      if (typeof cleanDateFormat === 'object' && cleanDateFormat?.Format) {
                        cleanDateFormat = cleanDateFormat.Format;
                      }
                      // Strip time components from date format string
                      cleanDateFormat = String(cleanDateFormat)
                        .replace(/\s*h{1,2}:mm:ss\s*[aApP][mM]\s*/gi, ' ')  // h:mm:ss A or hh:mm:ss A
                        .replace(/\s*H{1,2}:mm:ss\s*/gi, ' ')  // HH:mm:ss or H:mm:ss
                        .replace(/\s*h{1,2}:mm\s*[aApP][mM]\s*/gi, ' ')  // h:mm A or hh:mm A
                        .replace(/\s*H{1,2}:mm\s*/gi, ' ')  // HH:mm or H:mm
                        .replace(/\s*:ss\s*/gi, ' ')  // Standalone :ss pattern
                        .replace(/\s+[aApP][mM]?\s*$/gi, ' ')  // Trailing AM/PM
                        .replace(/\s+[aApP][mM]?\s+/gi, ' ')  // Standalone AM/PM in middle
                        .replace(/\s+/g, ' ')  // Clean up multiple spaces
                        .trim();
                      if (!cleanDateFormat || cleanDateFormat === '') {
                        cleanDateFormat = "MM/DD/YYYY";
                      }
                      
                      // Format date directly without timezone conversion - DatePicker already gives us local date
                      return dayjs(formik?.values?.RecuringJob?.StartDate).format(cleanDateFormat);
                    })()
                  : "-"}
              </Typography>
            </Col>
            <Col
              className="col-4 mx-1"
              style={{
                borderRight: "0.5px solid rgba(6,49,100, 0.8)",
              }}
              xl={4}
            >
              <Typography
                className="mb-0 text-blue-color"
                color="rgba(6, 49, 100, 30%)"
                style={{ fontSize: "12px" }}
              >
                Last
              </Typography>
              <Typography
                className="mb-0 text-blue-color"
                color="rgba(6, 49, 100, 30%)"
                style={{ fontSize: "12px" }}
              >
                {lastDate
                  ? (() => {
                      // Get clean date format (strip time components if present)
                      let cleanDateFormat = dateFormat || "MM/DD/YYYY";
                      if (typeof cleanDateFormat === 'object' && cleanDateFormat?.Format) {
                        cleanDateFormat = cleanDateFormat.Format;
                      }
                      // Strip time components from date format string
                      cleanDateFormat = String(cleanDateFormat)
                        .replace(/\s*h{1,2}:mm:ss\s*[aApP][mM]\s*/gi, ' ')  // h:mm:ss A or hh:mm:ss A
                        .replace(/\s*H{1,2}:mm:ss\s*/gi, ' ')  // HH:mm:ss or H:mm:ss
                        .replace(/\s*h{1,2}:mm\s*[aApP][mM]\s*/gi, ' ')  // h:mm A or hh:mm A
                        .replace(/\s*H{1,2}:mm\s*/gi, ' ')  // HH:mm or H:mm
                        .replace(/\s*:ss\s*/gi, ' ')  // Standalone :ss pattern
                        .replace(/\s+[aApP][mM]?\s*$/gi, ' ')  // Trailing AM/PM
                        .replace(/\s+[aApP][mM]?\s+/gi, ' ')  // Standalone AM/PM in middle
                        .replace(/\s+/g, ' ')  // Clean up multiple spaces
                        .trim();
                      if (!cleanDateFormat || cleanDateFormat === '') {
                        cleanDateFormat = "MM/DD/YYYY";
                      }
                      
                      // Format date directly without timezone conversion - lastDate is already in local time
                      return dayjs(lastDate).format(cleanDateFormat);
                    })()
                  : "-"}
              </Typography>
            </Col>
            <Col className="col-4 mx-1" xl={4}>
              <Typography
                className="mb-0 text-blue-color"
                color="rgba(6, 49, 100, 30%)"
                style={{ fontSize: "12px" }}
              >
                Total
              </Typography>
              <Typography
                className="mb-0 text-blue-color"
                color="rgba(6, 49, 100, 30%)"
                style={{ fontSize: "12px" }}
              >
                {formik?.values?.RecuringJob?.TotalVisits || 0}
              </Typography>
            </Col>
          </Grid>
        </CardBody>
      </Card>
      <Dialog open={modelOpen} onClose={() => setModelOpen(false)}>
        <DialogTitle className="borerBommoModel">
          <Grid className="d-flex justify-content-between">
            <Typography style={{ fontWeight: 600 }}>Custom Repeat</Typography>
            <Grid onClick={() => setModelOpen(false)}>
              <CancelIcon />
            </Grid>
          </Grid>
        </DialogTitle>
        <DialogContent>
          <Grid className="mt-4">
            <Grid
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Typography
                className="text-blue-color"
                style={{ fontWeight: 600 }}
              >
                Frequency :
              </Typography>
              <Select
                value={modalDuration || ""}
                onChange={handleDurationChangeCustom}
                style={{ borderRadius: "5px", width: "80%", height: "40px" }}
                className="text-blue-color border-blue-color durationSecondBox"
                displayEmpty
              >
                <MenuItem value="" disabled>
                  Select Duration
                </MenuItem>
                <MenuItem className="text-blue-color" value="day(s)">
                  Daily
                </MenuItem>
                <MenuItem className="text-blue-color" value="week(s)">
                  Weekly
                </MenuItem>
                <MenuItem className="text-blue-color" value="month(s)">
                  Monthly
                </MenuItem>
                <MenuItem className="text-blue-color" value="year(s)">
                  Yearly
                </MenuItem>
              </Select>
            </Grid>

            <Grid
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
              className="mt-4"
            >
              <Typography
                className="text-blue-color"
                style={{ fontWeight: 600 }}
              >
                Every
              </Typography>
              <Grid style={{ width: "80%" }} className="duration-custom">
                <InputText
                  name="Repeat Every"
                  id="Repeat Every"
                  placeholder="Enter Repeat Every"
                  label="Repeat Every"
                  type="number"
                  value={customFrequency}
                  onChange={(e) => setCustomFrequency(e.target.value)}
                  className="text-blue-color w-100"
                  fieldHeight="40px"
                  inputProps={{ min: 1, style: { padding: "5px 8px" } }}
                  endAdornment={
                    modalDuration ? (
                      <InputAdornment position="end">
                        <Typography
                          className="text-blue-color"
                          style={{ fontWeight: 400, whiteSpace: "nowrap" }}
                        >
                          {modalDuration === "day(s)"
                            ? "day(s)"
                            : modalDuration === "week(s)"
                            ? "week(s)"
                            : modalDuration === "month(s)"
                            ? "month(s)"
                            : modalDuration === "year(s)"
                            ? "year(s)"
                            : ""}
                        </Typography>
                      </InputAdornment>
                    ) : null
                  }
                />
              </Grid>
            </Grid>

            {modalDuration === "week(s)" && (
              <Grid
                className="mt-3"
                style={{ width: "80%", marginLeft: "auto" }}
              >
                <Select
                  value={selectedDay}
                  onChange={(e) => setSelectedDay(e.target.value)}
                  style={{ borderRadius: "5px", width: "100%", height: "40px" }}
                  className="text-blue-color border-blue-color durationSecondBox"
                  displayEmpty
                >
                  <MenuItem value="" disabled>
                    Select a Day
                  </MenuItem>
                  <MenuItem value="Sunday" className="text-blue-color">
                    Sunday
                  </MenuItem>
                  <MenuItem value="Monday" className="text-blue-color">
                    Monday
                  </MenuItem>
                  <MenuItem value="Tuesday" className="text-blue-color">
                    Tuesday
                  </MenuItem>
                  <MenuItem value="Wednesday" className="text-blue-color">
                    Wednesday
                  </MenuItem>
                  <MenuItem value="Thursday" className="text-blue-color">
                    Thursday
                  </MenuItem>
                  <MenuItem value="Friday" className="text-blue-color">
                    Friday
                  </MenuItem>
                  <MenuItem value="Saturday" className="text-blue-color">
                    Saturday
                  </MenuItem>
                </Select>
              </Grid>
            )}

            {modalDuration === "month(s)" && (
              <Grid
                className="mt-4"
                style={{ width: "80%", marginLeft: "auto" }}
              >
                <DatePicker
                  name="selectedDate"
                  label="Select Date"
                  placeholder="Select Date"
                  value={selectedDate || ""}
                  className="text-blue-color border-blue-color"
                  minDate={dayjs().startOf('day')}
                  shouldDisableDate={(date) => {
                    if (!date) return false;
                    return date.isBefore(dayjs().startOf('day'), 'day');
                  }}
                  onChange={(e) => setSelectedDate(e.target.value)}
                  format={dateFormat}
                />
              </Grid>
            )}
            {["day(s)", "week(s)", "month(s)", "year(s)"].includes(
              modalDuration
            ) && (
              <Grid
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  width: "100%",
                }}
                className="mt-4"
              >
                <Typography
                  className="text-blue-color"
                  style={{ fontWeight: 600, whiteSpace: "nowrap" }}
                >
                  Summary :
                </Typography>
                <Typography
                  className="text-blue-color"
                  style={{ fontWeight: 600, whiteSpace: "nowrap" }}
                >
                  {modalDuration === "day(s)"
                    ? `Every ${customFrequency} day(s)`
                    : modalDuration === "week(s)"
                    ? `Weekly on ${
                        selectedDay || "[day not selected]"
                      } every ${customFrequency} week(s)`
                    : modalDuration === "month(s)"
                    ? selectedDate
                      ? `Monthly on the ${moment(selectedDate).format(
                          "Do"
                        )} every ${customFrequency} month(s)`
                      : `Monthly every ${customFrequency} month(s)`
                    : `Yearly every ${customFrequency} year(s)`}
                </Typography>
              </Grid>
            )}
          </Grid>
        </DialogContent>
        <DialogActions>
          <WhiteButton
            className="planCancelBtn"
            style={{ marginTop: "3%" }}
            onClick={() => {
              setModelOpen(false);
              setSelectedDay("");
              setSelectedDate(null);
              setModalDuration("");
              setCustomFrequency("1");
              if (Repeats === "Custom") {
                setRepeats("");
                formik.setFieldValue("RecuringJob.Repeats", "");
                formik.setFieldValue("RecuringJob.TotalVisits", 0);
                formik.setFieldValue("RecuringJob.Visits", []);
              }
            }}
            label="Cancel"
          />

          <BlueButton
            className="mt-3 bg-button-blue-color"
            type="button"
            style={{ color: "white", height: "41px" }}
            onClick={handleCustomOk}
            label="OK"
          />
        </DialogActions>
      </Dialog>
    </Col>
  );
};

const CalendarJOB = ({
  isCalendarVisible,
  setIsCalendarVisible,
  dateFormat,
}) => {
  const formatDateWithUserTimezone = useUserTimezoneFormatter();
  const localizer = momentLocalizer(moment);
  const [events, setEvents] = useState([]);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loading, setloading] = useState(true);
  const [nameFormat, setNameFormat] = useState("FirstNameToLastName");
  const location = useLocation();
  const navigate = useNavigate();
  const { darkMode: adminCalendarDark } = useAdminDarkMode();

  const CustomToolbar = ({ label, onNavigate }) => {
    const goToBack = () => {
      onNavigate("PREV");
    };

    const goToNext = () => {
      onNavigate("NEXT");
    };

    return (
      <Grid className="rbc-toolbar">
        <BlueButton type="button" onClick={goToBack} label="Back" />

        <Typography className="rbc-toolbar-label">{label}</Typography>

        <BlueButton type="button" onClick={goToNext} lable="Next" />
      </Grid>
    );
  };

  const toggleCalendarVisibility = () => {
    setIsCalendarVisible(!isCalendarVisible);
    setIsCardVisible(!isCardVisible);
  };
  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };
  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
  };

  const fetchNameFormat = async () => {
    try {
      const res = await handleAuth(navigate, location);
      setNameFormat(res?.data?.NameSortOrder || "FirstNameToLastName");
    } catch (error) {
      console.error("Error fetching name format:", error);
    }
  };

  useEffect(() => {
    fetchNameFormat();
  }, []);

  const fetchSheduleData = async () => {
    setloading(true);
    try {
      const res = await AxiosInstance.get(`/v1/visit/get-visits`);
      const scheduleData = res?.data?.data;
      const mappedEvents = Array.isArray(scheduleData) ? scheduleData.map((item) => {
        
        // Handle end date - if EndDate is null/undefined, use StartDate as end date
        // Use parseLocalDate to prevent timezone-related date shifting
        const startDate = parseLocalDate(item?.StartDate);
        const endDate = item?.EndDate ? parseLocalDate(item?.EndDate) : startDate;
        
        const firstName = item?.customerDetails?.FirstName || item?.FirstName || "";
        const lastName = item?.customerDetails?.LastName || item?.LastName || "";
        const customerName = nameFormat === "LastNameToFirstName"
          ? `${lastName} ${firstName}`.trim()
          : `${firstName} ${lastName}`.trim();
        
        return {
        id: item?._id,
        title: item?.ItemName || "Visit",
        start: startDate,
        end: endDate,
        allDay: true,
        extendedProps: {
          VisitId: item?.VisitId,
          ContractNumber: item?.ContractNumber,
          ContractId: item?.ContractId,
          ItemName: item?.ItemName,
          FirstName: firstName,
          LastName: lastName,
          CustomerName: item?.CustomerName || customerName,
          description: item?.Note || "No description available",
          status: item?.Status || "Scheduled",
          priority: item?.Priority || "Normal",
          location: item?.Location || "Not specified",
          contact: item?.customerDetails?.PhoneNumber || "Not specified",
          notes: item?.Note || "No additional notes",
          workerDetails: item?.workerDetails || [],
          workerNames: item?.WorkerNames || [],
          customerDetails: item?.customerDetails || {},
          StartTime: item?.StartTime,
          EndTime: item?.EndTime,
          IsComplete: item?.IsComplete,
          IsConfirm: item?.IsConfirm,
          IsInvoiceCreated: item?.IsInvoiceCreated,
          OwnerName: item?.OwnerName || "Not specified",
        }
        };
      }) : [];
      setEvents(mappedEvents);
    } catch (error) {
      console.error("Error:", error?.message);
      setEvents([]);
    } finally {
      setloading(false);
    }
  };

  useEffect(() => {
    fetchSheduleData();
  }, []);
  const calendarRef = useRef(null);

  const [selectedEvent, setSelectedEvent] = useState(null);
  const [anchorPosition, setAnchorPosition] = useState(null);
  const [isCardVisible, setIsCardVisible] = useState(true);
  const [clickedDate, setClickedDate] = useState(null);
  const { CompanyUrl } = useParams();
  const [open, setOpen] = useState(false);
  const [mobileSelectedDate, setMobileSelectedDate] = useState(() => new Date());
  const [mobileDatePickerOpen, setMobileDatePickerOpen] = useState(false);

  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });

  /** Events for the currently selected date (mobile list view) - responsive only */
  const eventsForMobileDate = useMemo(() => {
    const d = moment(mobileSelectedDate).startOf("day");
    return (events || []).filter((ev) => ev.start && moment(ev.start).isSame(d, "day"));
  }, [events, mobileSelectedDate]);

  /** Week (7 days) containing mobileSelectedDate for the day strip */
  const mobileWeekDays = useMemo(() => {
    const start = moment(mobileSelectedDate).startOf("week");
    return Array.from({ length: 7 }, (_, i) => moment(start).add(i, "days").toDate());
  }, [mobileSelectedDate]);

  const getMobileCardTimeLine = (event) => {
    const allDay = event.allDay || event.extendedProps?.allDay;
    if (allDay) return { isAllDay: true, text: "All day" };
    const start = event.start ? moment(event.start) : null;
    const end = event.end ? moment(event.end) : null;
    if (!start) return { isAllDay: true, text: "All day" };
    const fmt = "h:mm A";
    const endStr = end && !end.isSame(start, "minute") ? ` – ${end.format(fmt)}` : "";
    return { isAllDay: false, text: `${start.format(fmt)}${endStr}` };
  };

  const getMobileCardLines = (event) => {
    const ep = event.extendedProps || {};
    const name = [ep.FirstName, ep.LastName].filter(Boolean).join(" ").trim();
    const lines = [];
    if (name) lines.push(`Client: ${name}`);
    lines.push(`Visit: ${ep.ItemName || event.title || "Visit"}`);
    return lines;
  };

  const openEventModalFromCard = (event) => {
    setSelectedEvent(event);
    setOpen(true);
  };

  const handleSlotClick = ({ start }) => {
    const hasEvent = events?.some((event) =>
      moment(event?.start)?.isSame(start, "day")
    );

    if (!hasEvent) {
      setClickedDate(start);
      const { x, y } = mousePosition;
      setAnchorPosition({ top: y, left: x });
    }
  };
  const eventPropGetter = () => ({
    style: {
      border: "none",
      display: "block",
    },
  });
  const handleEventClick = (event) => {
    if (event) {
      // For FullCalendar, custom data is in extendedProps
      
      setSelectedEvent(event);
      setOpen(true);
    } else {
      
    }
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedEvent(null);
  };

  const handlePopoverClose = () => {
    setAnchorPosition(null);
  };

  const renderEventContent = ({ event }) => (
    <div className="modern-event-content" style={{ background: "transparent" }}>
      <div
        className="event-icon"
        style={{
          fontSize: "14px",
          background: "transparent",
          marginBottom: "10px",
        }}
      >
        <img
          className={adminCalendarDark ? "contract-cal-event-icon--light" : undefined}
          src={adminCalendarDark ? VisitCalWhite : VisitCal}
          alt=""
        />
      </div>
      <div className="event-text">
        <div
          className={`event-title ${adminCalendarDark ? "contract-cal-event-title--dark" : "text-blue-color"}`}
        >
          {event?.extendedProps?.ItemName}
        </div>
      </div>
    </div>
  );

  const getStatusColor = (status) => {
    switch (status?.toLowerCase()) {
      case "completed":
        return "#10b981";
      case "in progress":
        return "#f59e0b";
      case "cancelled":
        return "#ef4444";
      case "scheduled":
        return "#3b82f6";
      default:
        return "#6b7280";
    }
  };

  const getPriorityColor = (priority) => {
    switch (priority?.toLowerCase()) {
      case "high":
        return "#ef4444";
      case "medium":
        return "#f59e0b";
      case "low":
        return "#10b981";
      default:
        return "#6b7280";
    }
  };

  const formatTime = (timeString) => {
    if (!timeString) return "";

    if (/^\d{2}:\d{2}$/.test(timeString)) {
      return timeString;
    }

    if (timeString.includes("T")) {
      try {
        const date = new Date(timeString);
        return date.toLocaleTimeString("en-US", {
          hour: "2-digit",
          minute: "2-digit",
          hour12: true,
        });
      } catch (error) {
        console.error("Error parsing time:", error);
        return timeString;
      }
    }

    try {
      const [hours, minutes] = timeString.split(":");
      const date = new Date();
      date.setHours(parseInt(hours, 10), parseInt(minutes, 10), 0);
      return date.toLocaleTimeString("en-US", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      });
    } catch (error) {
      console.error("Error parsing time:", error);
      return timeString;
    }
  };

  return (
    <Col className="col-12 mx-2 my-3 mb-0 first-tab" xl={12}>
      <Grid style={{ marginTop: "127px" }} className="calenderHeight">
        {isCalendarVisible && (
          <Grid
            style={{
              position: "relative",
            }}
          >
            {loading && (
              <Grid
                className="loading-overlay"
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  backgroundColor: "rgba(255, 255, 255, 0.8)",
                  zIndex: 1000,
                  borderRadius: "8px",
                }}
              >
                <CircularProgress size={50} sx={{ color: "#0f2b46" }} />
              </Grid>
            )}
            {isCalendarVisible && (
              <>
                <div className="calendar-wrapper add-contract-calendar desktop-view">
                  <div className="modern-calendar-wrapper">
                    <FullCalendar
                      plugins={[dayGridPlugin]}
                      events={events}
                      eventContent={renderEventContent}
                      eventClick={(info) => {
                        handleEventClick(info?.event);
                      }}
                      headerToolbar={{
                        left: "prev,next",
                        center: "title",
                        right: "dayGridMonth,dayGridWeek,dayGridDay",
                      }}
                      eventPropGetter={eventPropGetter}
                      eventClassNames={() =>
                        adminCalendarDark ? ["contract-cal-event-dark"] : []
                      }
                      onSelectSlot={handleSlotClick}
                      popup={true}
                      dayMaxEvents={3}
                      className="modern-fullcalendar"
                    />
                  </div>
                </div>
                {/* Mobile view: date line + day strip + event cards - responsive only */}
                <div className="calendar-wrapper add-contract-calendar mobile-view">
                  <div className="mobile-schedule-inner add-contract-mobile-schedule">
                    <header className="mobile-calendar-header">
                      <button
                        type="button"
                        className="mobile-date-picker-trigger"
                        onClick={() => setMobileDatePickerOpen(true)}
                        aria-label="Select date"
                      >
                        <span className="mobile-date-one-line">
                          {moment(mobileSelectedDate).format("dddd MMMM D, YYYY")}
                        </span>
                        <CalendarMonthRoundedIcon className="mobile-date-picker-icon" />
                      </button>
                      <div className="mobile-day-strip">
                        {mobileWeekDays.map((day) => {
                          const isSelected = moment(day).isSame(moment(mobileSelectedDate), "day");
                          return (
                            <button
                              key={day.getTime()}
                              type="button"
                              className={`mobile-day-dot ${isSelected ? "selected" : ""}`}
                              onClick={() => setMobileSelectedDate(day)}
                              aria-label={moment(day).format("ddd MMM D")}
                            >
                              {moment(day).format("ddd").charAt(0)}
                            </button>
                          );
                        })}
                      </div>
                    </header>
                    <div className="mobile-event-list">
                      {loading ? (
                        <Box display="flex" justifyContent="center" py={3}>
                          <CircularProgress size={40} sx={{ color: "#0f2b46" }} />
                        </Box>
                      ) : eventsForMobileDate.length === 0 ? (
                        <p className="mobile-no-events">No events on this date.</p>
                      ) : (
                        eventsForMobileDate.map((event) => {
                          const timeLine = getMobileCardTimeLine(event);
                          const lines = getMobileCardLines(event);
                          return (
                            <div
                              key={event.id}
                              className="event-card-mobile add-contract-event-card"
                              onClick={() => openEventModalFromCard(event)}
                            >
                              <div className="event-card-mobile-time">
                                {timeLine.isAllDay ? (
                                  <span className="event-time-all-day">{timeLine.text}</span>
                                ) : (
                                  <span className="event-time-range">{timeLine.text}</span>
                                )}
                              </div>
                              {lines.length > 0 && (
                                <div className="event-card-mobile-lines">
                                  {lines.map((line, idx) => (
                                    <div key={idx} className="event-card-mobile-line">
                                      {line}
                                    </div>
                                  ))}
                                </div>
                              )}
                              <button
                                type="button"
                                className="view-details-btn"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  openEventModalFromCard(event);
                                }}
                              >
                                View Info
                              </button>
                            </div>
                          );
                        })
                      )}
                    </div>
                  </div>
                </div>
              </>
            )}
          </Grid>
        )}
      </Grid>

      {/* Mobile date picker - responsive only */}
      <Dialog
        open={mobileDatePickerOpen}
        onClose={() => setMobileDatePickerOpen(false)}
        maxWidth="xs"
        fullWidth
        PaperProps={{ style: { borderRadius: 16, padding: 8 } }}
        className="mobile-date-picker-dialog add-contract-date-picker-dialog"
      >
        <DialogTitle style={{ textAlign: "center", paddingBottom: 0 }}>
          Select date
        </DialogTitle>
        <DialogContent style={{ paddingTop: 8 }}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DateCalendar
              value={dayjs(mobileSelectedDate)}
              onChange={(newDate) => {
                if (newDate) {
                  setMobileSelectedDate(newDate.toDate());
                  setMobileDatePickerOpen(false);
                }
              }}
              showDaysOutsideCurrentMonth
            />
          </LocalizationProvider>
        </DialogContent>
      </Dialog>

      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth="md"
        fullWidth
        className="modern-event-dialog"
        PaperProps={{
          className: "modern-dialog-paper",
          style: {
            borderRadius: "12px",
            border: "1px solid #e5e7eb",
            overflow: "hidden",
            boxShadow: "0 10px 30px rgba(15, 43, 70, 0.12)",
          },
        }}
      >
        {/* JOB-3258: modernize the Visit Details modal — soft header tint, rounded
            corners, subtle dividers instead of harsh navy borders everywhere. */}
        <DialogTitle className="modern-dialog-title" style={{ padding: 0 }}>
          <div
            className="dialog-header"
            style={{
              backgroundColor: "#f8fafc",
              color: "var(--navy-deep, #0f2b46)",
              padding: "18px 24px",
              position: "relative",
              borderBottom: "1px solid #e5e7eb",
            }}
          >
            <div
              className="dialog-title-content"
              style={{ display: "flex", alignItems: "center", gap: "14px" }}
            >
              <div
                className="event-icon-large"
                style={{
                  width: "44px",
                  height: "44px",
                  backgroundColor: "#dbeafe",
                  borderRadius: "10px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexShrink: 0,
                }}
              >
                <img
                  className={adminCalendarDark ? "contract-cal-dialog-icon--light" : undefined}
                  src={adminCalendarDark ? VisitCalWhite : VisitCal}
                  alt=""
                  style={{ width: 22, height: 22 }}
                />
              </div>
              <div className="title-text">
                <Typography
                  variant="h5"
                  className="event-main-title"
                  style={{
                    fontWeight: 600,
                    marginBottom: "2px",
                    fontSize: "18px",
                    color: "var(--navy-deep, #0f2b46)",
                    lineHeight: 1.3,
                    textTransform: "capitalize",
                  }}
                >
                  {selectedEvent?.extendedProps?.ItemName || "Event Details"}
                </Typography>
                <Typography
                  variant="body2"
                  className="event-subtitle-text"
                  style={{
                    fontSize: "13px",
                    color: "#6b7280",
                  }}
                >
                  Visit Details · Contract #{selectedEvent?.extendedProps?.ContractNumber}
                </Typography>
              </div>
            </div>
            <CloseIcon
              onClick={handleClose}
              className="close-icon"
              style={{
                cursor: "pointer",
                fontSize: "22px",
                position: "absolute",
                top: "18px",
                right: "20px",
                color: "#6b7280",
              }}
            />
          </div>
        </DialogTitle>

        <DialogContent
          className="modern-dialog-content"
          sx={{
            /* JOB-3258: give the first card room at the top so it's clearly
               separated from the header bar (was looking joined/flush). */
            padding: { xs: "20px 16px 18px", sm: "24px 20px 20px" },
            backgroundColor: "var(--bg-white-color, #ffffff)",
          }}
        >
          {selectedEvent && (
            <div
              className="event-details-container"
              style={{ display: "flex", flexDirection: "column", gap: "14px" }}
            >
              <div className="event-info-section">
                <div
                  className="info-card"
                  style={{
                    backgroundColor: "#ffffff",
                    borderRadius: "10px",
                    padding: "18px 20px",
                    border: "1px solid #e5e7eb",
                  }}
                >
                  <div className="info-header" style={{ marginBottom: "14px" }}>
                    <Typography
                      variant="h6"
                      className="info-title"
                      style={{
                        fontWeight: 600,
                        color: "var(--navy-deep, #0f2b46)",
                        fontSize: "14px",
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                      }}
                    >
                      <img src={BasicInfo} alt="" style={{ width: 16, height: 16 }} /> Basic Information
                    </Typography>
                  </div>
                  <div
                    className="info-grid"
                    style={{
                      display: "grid",
                      gridTemplateColumns:
                        "repeat(auto-fit, minmax(250px, 1fr))",
                      gap: "16px",
                    }}
                  >
                    <div className="info-item">
                      <label
                        style={{
                          fontSize: "11px",
                          fontWeight: 600,
                          color: "#6b7280",
                          letterSpacing: "0.4px",
                          textTransform: "uppercase",
                        }}
                      >
                        Customer Name
                      </label>
                      <span
                        style={{
                          fontSize: "14px",
                          fontWeight: 500,
                          color: "var(--navy-deep, #0f2b46)",
                        }}
                      >
                        {(() => {
                          const firstName = selectedEvent?.extendedProps?.FirstName || "";
                          const lastName = selectedEvent?.extendedProps?.LastName || "";
                          return nameFormat === "LastNameToFirstName"
                            ? `${lastName} ${firstName}`.trim()
                            : `${firstName} ${lastName}`.trim();
                        })()}
                      </span>
                    </div>
                    <div className="info-item">
                      <label
                        style={{
                          fontSize: "11px",
                          fontWeight: 600,
                          color: "#6b7280",
                          letterSpacing: "0.4px",
                          textTransform: "uppercase",
                        }}
                      >
                        Worker Name(s)
                      </label>
                      <div
                        style={{
                          fontSize: "14px",
                          fontWeight: 500,
                          color: "var(--navy-deep, #0f2b46)",
                          display: "flex",
                          flexDirection: "column",
                          gap: "2px",
                        }}
                      >
                        {selectedEvent?.extendedProps?.workerDetails &&
                        selectedEvent?.extendedProps?.workerDetails?.length > 0 ? (
                          selectedEvent?.extendedProps?.workerDetails?.map((w, index) => {
                            const name = w.OwnerName
                              ? w.OwnerName
                              : `${w.FirstName || ""} ${
                                  w.LastName || ""
                                }`.trim();
                            return (
                              <span key={index}>
                                {index + 1}. {name}
                              </span>
                            );
                          })
                        ) : (
                          <span>No workers assigned</span>
                        )}
                      </div>
                    </div>

                    <div className="info-item">
                      <label
                        style={{
                          fontSize: "11px",
                          fontWeight: 600,
                          color: "#6b7280",
                          letterSpacing: "0.4px",
                          textTransform: "uppercase",
                        }}
                      >
                        Start Date
                      </label>
                      <span
                        style={{
                          fontSize: "14px",
                          fontWeight: 500,
                          color: "var(--navy-deep, #0f2b46)",
                        }}
                      >
                        {formatDateWithUserTimezone(selectedEvent?.start, {
                          dateFormat: dateFormat,
                          includeSeconds: false
                        })}
                      </span>
                    </div>
                    <div className="info-item">
                      <label
                        style={{
                          fontSize: "11px",
                          fontWeight: 600,
                          color: "#6b7280",
                          letterSpacing: "0.4px",
                          textTransform: "uppercase",
                        }}
                      >
                        End Date
                      </label>
                      <span
                        style={{
                          fontSize: "14px",
                          fontWeight: 500,
                          color: "var(--navy-deep, #0f2b46)",
                        }}
                      >
                        {selectedEvent?.end && moment(selectedEvent?.end).isValid() 
                          ? formatDateWithUserTimezone(selectedEvent?.end, {
                              dateFormat: dateFormat,
                              includeSeconds: false
                            })
                          : selectedEvent?.start && moment(selectedEvent?.start).isValid()
                          ? formatDateWithUserTimezone(selectedEvent?.start, {
                              dateFormat: dateFormat,
                              includeSeconds: false
                            })
                          : "No end date"}
                      </span>
                    </div>
                    <div className="info-item">
                      <label
                        style={{
                          fontSize: "11px",
                          fontWeight: 600,
                          color: "#6b7280",
                          letterSpacing: "0.4px",
                          textTransform: "uppercase",
                        }}
                      >
                        Time
                      </label>
                      <span
                        style={{
                          fontSize: "14px",
                          fontWeight: 500,
                          color: "var(--navy-deep, #0f2b46)",
                        }}
                      >
                        {selectedEvent?.extendedProps?.StartTime && selectedEvent?.extendedProps?.EndTime
                          ? `${formatTime(
                              selectedEvent?.extendedProps?.StartTime
                            )} - ${formatTime(selectedEvent?.extendedProps?.EndTime)}`
                          : "No time specified"}
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div className="status-section">
                <div
                  className="status-card"
                  style={{
                    backgroundColor: "#ffffff",
                    borderRadius: "10px",
                    padding: "14px 20px",
                    border: "1px solid #e5e7eb",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <div className="status-header">
                    <Typography
                      variant="h6"
                      className="status-title"
                      style={{
                        fontWeight: 600,
                        color: "var(--navy-deep, #0f2b46)",
                        fontSize: "14px",
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                      }}
                    >
                      <img src={ProgressVisit} alt="" style={{ width: 16, height: 16 }} /> Visit Status
                    </Typography>
                  </div>
                  <div
                    className="status-grid"
                    style={{
                      display: "grid",
                      gridTemplateColumns:
                        "repeat(auto-fit, minmax(200px, 1fr))",
                      gap: "16px",
                    }}
                  >
                    <div
                      className="status-item"
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "8px",
                      }}
                    >
                      <span
                        className="status-badge"
                        style={{
                          backgroundColor: getStatusColor(
                            selectedEvent?.extendedProps?.status || "Scheduled"
                          ),
                          color: "white",
                          padding: "5px 14px",
                          borderRadius: "999px",
                          fontSize: "12px",
                          fontWeight: 600,
                          textAlign: "center",
                          textTransform: "capitalize",
                          display: "inline-block",
                          width: "fit-content",
                          letterSpacing: "0.3px",
                        }}
                      >
                        {selectedEvent?.extendedProps?.status || "Scheduled"}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </DialogContent>

        <DialogActions
          className="modern-dialog-actions"
          style={{
            padding: "14px 24px",
            backgroundColor: "#f8fafc",
            borderTop: "1px solid #e5e7eb",
            display: "flex",
            justifyContent: "flex-end",
            gap: "12px",
          }}
        >
          <WhiteButton
            onClick={handleClose}
            label="Close"
            className="dialog-close-btn"
            style={{
              borderRadius: "8px",
              padding: "8px 18px",
              fontSize: "13px",
              fontWeight: 500,
              border: "1px solid #d1d5db",
              color: "var(--navy-deep, #0f2b46)",
              backgroundColor: "#ffffff",
            }}
          />
        </DialogActions>
      </Dialog>

      <Typography
        open={Boolean(anchorPosition)}
        anchorReference="anchorPosition"
        anchorPosition={anchorPosition}
        onClose={handlePopoverClose}
        PaperProps={{
          style: {
            top: anchorPosition ? `${anchorPosition?.top}px` : undefined,
            left: anchorPosition ? `${anchorPosition?.left}px` : undefined,
            position: "absolute",
          },
        }}
      ></Typography>
    </Col>
  );
};

const ClientMessage = ({ formik }) => {
  return (
    <Col className="col-5 order-sm-1 messageinput" xl={5}>
      <FormGroup>
        <InputText
          value={formik?.values?.CustomerMessage}
          onChange={formik?.handleChange}
          onBlur={formik?.handleBlur}
          error={
            formik?.touched?.CustomerMessage &&
            Boolean(formik?.errors?.CustomerMessage || "")
          }
          helperText={
            formik?.touched?.CustomerMessage && formik?.errors?.CustomerMessage
          }
          name="CustomerMessage"
          label="CustomerMessage"
          type="text"
          className="text-blue-color w-100 m-0 mb-3"
          fieldHeight="44px"
        />
      </FormGroup>
      <FormGroup>
        <InputText
          value={formik?.values?.ContractDisclaimer}
          onChange={formik?.handleChange}
          onBlur={formik?.handleBlur}
          error={
            formik?.touched?.ContractDisclaimer &&
            Boolean(formik?.errors?.ContractDisclaimer)
          }
          helperText={
            formik?.touched?.ContractDisclaimer &&
            formik?.errors?.ContractDisclaimer
          }
          name="ContractDisclaimer"
          label="ContractDisclaimer"
          type="text"
          className="text-blue-color w-100 m-0 mb-3"
          fieldHeight="44px"
        />
      </FormGroup>
    </Col>
  );
};

const AddQuoteDiscount = ({ lineItems, formik }) => {
  const [showDiscount, setShowDiscount] = useState(false);
  const [showTax, setShowTax] = useState(false);
  const { userType } = useUserType();
  const isDonationMode = userType === "donor";
  const calculateSubTotal = () => {
    const total = lineItems?.reduce(
      (sum, item) => sum + Number(item.Total || 0),
      0
    );
    return total;
  };

  const subTotal = calculateSubTotal();
  const discountAmount = formik?.values?.Discount
    ? (Number(formik?.values?.Discount) * subTotal) / 100
    : 0;
  const discountedTotal = subTotal - discountAmount;
  const taxAmount = formik?.values?.Tax
    ? (Number(formik?.values?.Tax) * discountedTotal) / 100
    : 0;
  const Total = (discountedTotal + taxAmount)?.toFixed(2);

  return (
    <Col className="col-7 order-sm-2 totalinput" xl={7}>
      <Table>
        <TableBody>
          <TableRow>
            <TableCell className="text-blue-color" style={{ height: "50px" }}>
              Subtotal
            </TableCell>
            <TableCell className="text-end text-blue-color">
              {`$${new Intl.NumberFormat("en-US", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              }).format(subTotal ?? 0)}`}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell className="text-blue-color" style={{ height: "50px" }}>
              Discount
            </TableCell>
            <TableCell
              className={`d-flex ${
                !showDiscount
                  ? "justify-content-end"
                  : "justify-content-between"
              }`}
            >
              {showDiscount && (
                <Typography
                  style={{ position: "relative", display: "inline-block" }}
                >
                  <InputText
                    value={formik?.values?.Discount}
                    onChange={formik?.handleChange}
                    onBlur={formik?.handleBlur}
                    error={
                      formik?.touched?.Discount &&
                      Boolean(formik?.errors?.Discount)
                    }
                    helperText={
                      formik?.touched?.Discount && formik?.errors?.Discount
                    }
                    name="Discount"
                    label="Discount"
                    type="text"
                    className="text-blue-color w-100 m-0 mb-3"
                    fieldHeight="44px"
                  />
                  <Typography
                    style={{
                      position: "absolute",
                      right: "10px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      pointerEvents: "none",
                    }}
                    className="text-blue-color"
                  >
                    %
                  </Typography>
                </Typography>
              )}
              <Typography
                className="text-blue-color underline-u"
                style={{
                  fontWeight: 600,
                  cursor: "pointer",
                  textAlign: "end",
                  marginBottom: "9px",
                }}
                onClick={() => setShowDiscount(!showDiscount)}
              >
                {discountAmount > 0
                  ? formatUSD(discountAmount)
                  : "Add Discount"}
              </Typography>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell className="text-blue-color" style={{ height: "50px" }}>
              Tax
            </TableCell>
            <TableCell
              className={`d-flex ${
                !showTax ? "justify-content-end" : "justify-content-between"
              }`}
            >
              {showTax && (
                <Typography
                  style={{ position: "relative", display: "inline-block" }}
                >
                  <InputText
                    value={formik?.values?.Tax}
                    onChange={formik?.handleChange}
                    onBlur={formik?.handleBlur}
                    error={formik?.touched?.Tax && Boolean(formik?.errors?.Tax)}
                    helperText={formik?.touched?.Tax && formik?.errors?.Tax}
                    name="Tax"
                    label="Tax"
                    type="text"
                    className="text-blue-color w-100 m-0 mb-3"
                    fieldHeight="44px"
                  />
                  <Typography
                    className="text-blue-color"
                    style={{
                      position: "absolute",
                      right: "10px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      pointerEvents: "none",
                    }}
                  >
                    %
                  </Typography>
                </Typography>
              )}
              <Typography
                className="text-blue-color underline-u"
                style={{
                  fontWeight: 600,
                  cursor: "pointer",
                  marginBottom: "9px",
                }}
                onClick={() => setShowTax(!showTax)}
                isDonationMode={isDonationMode}
              >
                {taxAmount > 0 ? formatUSD(taxAmount) : "Add Tax"}
              </Typography>
            </TableCell>
          </TableRow>
          <TableRow className="last-row border-0">
            <TableCell className="border-0 text-blue-color">
              <Typography className="bold-text">Total</Typography>
            </TableCell>
            <TableCell className="text-end border-0 text-blue-color">
              <Typography className="bold-text">${Total}</Typography>
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </Col>
  );
};

const Team = ({ setIds = (assignPersonId) => {}, ids, isAddTeam = true }) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [selectedTeams, setSelectedTeams] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [checkedState, setCheckedState] = useState(false);
  const [teamData, setTeamData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [tokenDecode, setTokenDecode] = useState({});
  const [workerId, setAssignPersonId] = useState([]);
  const [loader, setloader] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const [nameFormat, setNameFormat] = useState("FirstNameToLastName");
  
  const fetchDatas = async () => {
    try {
      const res = await handleAuth(navigate, location);
      setTokenDecode(res?.data);
      setNameFormat(res?.data?.NameSortOrder || "FirstNameToLastName");
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  useEffect(() => {
    fetchDatas();
  }, []);
  const fetchTeamData = async () => {
    setLoading(true);
    try {
      const CompanyId =
        getItem("CompanyId") || tokenDecode?.CompanyId;

      if (!CompanyId) {
        console.error("CompanyId is not found.");
        return;
      }

      const response = await AxiosInstance.get(`v1/user/${CompanyId}`);

      if (response?.status === 200) {
        setTeamData(response?.data?.data);
      } else {
        console.error("Error fetching team data:", response);
      }
    } catch (error) {
      console.error("Error fetching team data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTeamData();
  }, [tokenDecode]);

  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
  };

  const formikTeam = useFormik({
    initialValues: {
      FullName: "",
      EmailAddress: "",
      MobileNumber: "",
      WorkerId: "",
    },
    validationSchema: Yup.object({
      FullName: Yup.string().required("Full Name is required"),
      EmailAddress: Yup.string()
        .email("Invalid email address")
        .required("Email is required"),
      MobileNumber: Yup.string()
        .required("Phone number is required")
        .matches(
          /^\(\d{3}\) \d{3}-\d{4}$/,
          "Phone number must be in the format (xxx) xxx-xxxx"
        ),
    }),
    onSubmit: async (values) => {
      try {
        setLoading(true);
        const CompanyId =
          getItem("CompanyId") || tokenDecode?.CompanyId;

        if (!CompanyId) {
          console.error("CompanyId is not found.");
          return;
        }
        const object = {
          ...values,
          CompanyId: CompanyId,
          WorkerId: values?.WorkerId,
          FullName: values?.FullName,
          EmailAddress: values?.EmailAddress,
          PhoneNumber: values?.MobileNumber,
          AddedAt: new Date(),
          Role: "Worker",
        };

        const response = await AxiosInstance.post(`/v1/user`, object);
        if (response?.data?.statusCode === 200) {
          showToast.success(response?.data?.message);
          toggleModal();
          fetchTeamData();
          formikTeam.resetForm();
        } else if (response?.data?.statusCode === 202) {
          showToast.error(response?.data?.message);
        }
      } catch (error) {
        if (error?.response) {
          console.error(
            "Server responded with an error:",
            error?.response?.data
          );
          setTimeout(() => {
            showToast.error(
              error?.response?.data?.message || "We couldn't save this contract. Please try again in a moment."
            );
          }, 500);
        } else if (error?.request) {
          console.error("No response received:", error?.request);
          setTimeout(() => {
            showToast.error(
              "No response from the server, please try again later."
            );
          }, 500);
        } else {
          console.error("Error during request setup:", error?.message);
          setTimeout(() => {
            showToast.error("Error occurred while sending request.");
          }, 500);
        }
      } finally {
        setLoading(false);
      }
    },
  });

  const handleRemoveTeam = (team) => {
    setSelectedTeams((prevTeams) =>
      prevTeams.filter(
        (selectedTeam) => selectedTeam?.WorkerId !== team?.WorkerId
      )
    );

    setCheckedState((prevState) => {
      const updatedState = { ...prevState };
      delete updatedState[team?.WorkerId];
      return updatedState;
    });

    setAssignPersonId((prevIds) =>
      prevIds.filter((id) => id !== team?.WorkerId)
    );

    setIds((prevIds) => prevIds.filter((id) => id !== team?.WorkerId));
  };

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  const handleOutsideClick = () => {
    toggleDropdown();
  };

  const handleTeamSelect = (event, team) => {
    if (event.target.checked) {
      setSelectedTeams((prevTeams) => [
        ...prevTeams,
        {
          FullName: team?.FullName,
          EmailAddress: team?.EmailAddress,
          WorkerId: team?.WorkerId,
        },
      ]);

      setCheckedState((prevState) => ({
        ...prevState,
        [team?.WorkerId]: true,
      }));

      setIds((prevIds) => [...prevIds, team?.WorkerId]);
      setAssignPersonId((prevIds) => [...prevIds, team?.WorkerId]);
    } else {
      setSelectedTeams((prevTeams) =>
        prevTeams.filter(
          (selectedTeam) => selectedTeam?.WorkerId !== team?.WorkerId
        )
      );

      setCheckedState((prevState) => ({
        ...prevState,
        [team?.WorkerId]: false,
      }));

      setIds((prevIds) => prevIds.filter((id) => id !== team?.WorkerId));
      setAssignPersonId((prevIds) =>
        prevIds.filter((id) => id !== team?.WorkerId)
      );
    }
  };
  const formatPhoneNumber = (value) => {
    const PhoneNumber = value.replace(/[^\d]/g, "");
    const limitedPhoneNumber = PhoneNumber.slice(0, 10);
    const match = limitedPhoneNumber.match(/^(\d{0,3})(\d{0,3})(\d{0,4})$/);

    if (match) {
      let formattedNumber = "";
      if (match[1].length >= 3) {
        formattedNumber = `(${match[1]}) `;
      } else {
        formattedNumber = match[1];
      }
      formattedNumber += match[2];
      if (match[3]) {
        formattedNumber += `-${match[3]}`;
      }

      return formattedNumber;
    }
    return limitedPhoneNumber;
  };
  const handlePhoneChange = (e) => {
    if (formikTeam?.values?.MobileNumber?.length > e.target.value?.length) {
      formikTeam?.setFieldValue("MobileNumber", e.target.value);
    } else {
      const formattedValue = formatPhoneNumber(e.target.value);
      formikTeam?.setFieldValue("MobileNumber", formattedValue);
    }
  };

  return (
    <Col className=" teamAssignBox">
      <Grid className="jobs">
        <Grid className="team-card" style={{ width: "100%" }}>
          <Card
            style={{ height: "140px" }}
            className="teamAndAssign border-blue-color"
          >
            <CardHeader
              style={{
                display: "flex",
                justifyContent: "space-between",
                borderBottom: "none",
                background: "none",
              }}
              className="team-header"
            >
              <Typography
                className="text-blue-color heading-three"
                style={{ fontWeight: 600 }}
              >
                Team
              </Typography>
              <Grid className="assignbtn">
                <BlueButton
                  className="bg-blue-color text-white-color "
                  outline
                  style={{
                    padding: "0 14px 0 14px",
                    fontSize: "12px",
                    marginTop: 0,
                    height: "32px",
                  }}
                  onClick={toggleDropdown}
                  label="+ Assign"
                />
                {isDropdownOpen && (
                  <Grid
                    maxWidth="md"
                    fullWidth
                    className="assigndrop"
                    style={{
                      position: "absolute",
                      boxShadow: "var(--shadow-md)",
                      borderRadius: "4px",
                      marginTop: "10px",
                      padding: "10px",
                      zIndex: 1000,
                      right: 0,
                    }}
                  >
                    <Card
                      style={{
                        height: "300px",
                      }}
                    >
                      <CardHeader
                        className="text-white-color bg-blue-color"
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        Select team
                        <CloseIcon
                          onClick={toggleDropdown}
                          style={{ cursor: "pointer" }}
                        />
                      </CardHeader>
                      <CardBody
                        style={{
                          scrollbarWidth: "thin",
                          overflowY: "auto",
                          height: "100px",
                        }}
                      >
                        <Grid onClick={handleOutsideClick}>
                          {teamData && teamData?.length > 0 ? (
                            teamData.map((person) => (
                              <FormGroup
                                check
                                className="my-3 mb-0"
                                key={person.WorkerId}
                              >
                                <Input
                                  type="checkbox"
                                  checked={
                                    checkedState &&
                                    !!checkedState[person?.WorkerId]
                                  }
                                  onChange={(e) => handleTeamSelect(e, person)}
                                />

                                <Label
                                  style={{
                                    fontSize: "16px",
                                    color: "rgba(6,49,100,0.7)",
                                    fontWeight: "400",
                                    marginBottom: 0,
                                  }}
                                >
                                  {person?.FullName}
                                </Label>
                                <Label
                                  style={{
                                    fontSize: "16px",
                                    color: "rgba(6,49,100,0.7)",
                                    fontWeight: "400",
                                    marginBottom: 0,
                                  }}
                                >
                                  <span> ( {person?.EmailAddress} )</span>
                                </Label>
                              </FormGroup>
                            ))
                          ) : (
                            <Typography>No team members found.</Typography>
                          )}
                        </Grid>

                        <hr />
                      </CardBody>
                      <CardFooter>
                        <BlueButton
                          className="text-blue-color text-white-color text-white-color bg-button-blue-color"
                          style={{
                            border: "none",
                            fontWeight: "400",
                            padding: "8px",
                            fontSize: "12px",
                          }}
                          onClick={toggleModal}
                          label="+ Create Worker"
                        />
                      </CardFooter>
                    </Card>
                    <Modal isOpen={isModalOpen} toggle={toggleModal}>
                      <ModalHeader
                        toggle={toggleModal}
                        className="text-blue-color"
                      >
                        Add new worker
                      </ModalHeader>
                      <ModalBody
                        className="nozindex"
                        style={{ borderBottom: "none" }}
                      >
                        <FormGroup>
                          <Input
                            name="FullName"
                            placeholder="Enter full name"
                            type="text"
                            className="text-blue-color w-100 mb-3  border-blue-color"
                            value={formikTeam?.values?.FullName}
                            onChange={formikTeam?.handleChange}
                            onBlur={formikTeam?.handleBlur}
                            invalid={
                              formikTeam?.touched?.FullName &&
                              Boolean(formikTeam?.errors?.FullName)
                            }
                          />
                          {formikTeam?.touched?.FullName &&
                          formikTeam?.errors?.FullName ? (
                            <Grid className="text-danger AdduserModelBox">
                              {formikTeam?.errors?.FullName}
                            </Grid>
                          ) : null}
                        </FormGroup>
                        <FormGroup className="AdduserModelBoxes">
                          <Input
                            name="EmailAddress"
                            placeholder="Enter email"
                            type="text"
                            className="text-blue-color w-100 mb-3 border-blue-color"
                            value={formikTeam?.values?.EmailAddress}
                            onChange={formikTeam?.handleChange}
                            onBlur={formikTeam?.handleBlur}
                            invalid={
                              formikTeam?.touched?.EmailAddress &&
                              Boolean(formikTeam?.errors?.EmailAddress)
                            }
                          />
                          {formikTeam?.touched?.EmailAddress &&
                          formikTeam?.errors?.EmailAddress ? (
                            <Grid className="text-danger AdduserModelBox">
                              {formikTeam?.errors?.EmailAddress}
                            </Grid>
                          ) : null}
                        </FormGroup>
                        <FormGroup className="AdduserModelBoxes">
                          <Input
                            name="MobileNumber"
                            placeholder="Enter mobile number"
                            type="text"
                            className="text-blue-color w-100 mb-3 border-blue-color"
                            value={formikTeam?.values?.MobileNumber}
                            onChange={handlePhoneChange}
                            onBlur={formikTeam?.handleBlur}
                            invalid={
                              formikTeam?.touched?.MobileNumber &&
                              Boolean(formikTeam?.errors?.MobileNumber)
                            }
                          />
                          {formikTeam?.touched?.MobileNumber &&
                          formikTeam?.errors?.MobileNumber ? (
                            <div className="text-danger">
                              {formikTeam?.errors?.MobileNumber}
                            </div>
                          ) : null}
                        </FormGroup>
                      </ModalBody>
                      <ModalFooter className="adduserModelTop justify-content-between">
                        <WhiteButton
                          onClick={() => {
                            formikTeam.resetForm();
                            toggleModal();
                          }}
                          label="Cancel"
                        />
                        {loading ? (
                          <Grid className="d-flex justify-content-center">
                            <LoaderComponent
                              loader={loader}
                              height="20"
                              width="20"
                            />
                          </Grid>
                        ) : (
                          <BlueButton
                            className="svaeUserModelWidth"
                            onClick={formikTeam?.handleSubmit}
                            label="Save Worker"
                          />
                        )}
                      </ModalFooter>
                    </Modal>
                  </Grid>
                )}
              </Grid>
            </CardHeader>
            <CardBody
              className="addignTeamOvefFlowWidth"
              style={{ maxHeight: "100px", overflowY: "auto" }}
            >
              <Grid
                style={{ marginTop: "-10px", height: "18px" }}
                className="assingPersoneSeeHereToAssign"
              >
                {selectedTeams?.map((team, index) => (
                  <Grid
                    key={index}
                    className="tag assignPersonNameHereTo"
                    style={{
                      marginTop: "6px",
                      marginLeft: "10px",
                      gap: "10px",
                    }}
                  >
                    <Typography
                      className="tag-text"
                      style={{ fontSize: "16px" }}
                    >
                      <span>
                        {team?.FullName || "FullName not available"} -
                        {team?.EmailAddress || "EmailAddress not available"}
                      </span>
                    </Typography>
                    <button
                      className="tag-close"
                      onClick={() => handleRemoveTeam(team)}
                      style={{
                        backgroundColor: "#e0e0e0",
                        border: "none",
                        borderRadius: "50%",
                        width: "24px",
                        height: "24px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        cursor: "pointer",
                        transition: "background-color 0.3s",
                      }}
                      onMouseOver={(e) =>
                        (e.currentTarget.style.backgroundColor = "#d0d0d0")
                      }
                      onMouseOut={(e) =>
                        (e.currentTarget.style.backgroundColor = "#e0e0e0")
                      }
                    >
                      <CloseIcon style={{ fontSize: "16px" }} />
                    </button>
                  </Grid>
                ))}
              </Grid>
            </CardBody>
          </Card>
        </Grid>
      </Grid>
    </Col>
  );
};
const NoDataFound = ({ isDonationMode }) => {
  return (
    <>
      <Grid>
        <Grid className="d-flex justify-content-center">
          {isDonationMode ? (
            <img src={DonorNoData} alt="Donor" />
          ) : (
            <img src={NoData} alt="No Data" />
          )}
        </Grid>
        <Typography
          style={{ fontSize: "14px" }}
          className={`${
            isDonationMode ? "text-donor-color" : "text-blue-color"
          }`}
        >
          No Data Found
        </Typography>
      </Grid>
    </>
  );
};

export {
  InternalNotes,
  OneOffContract,
  RecurringContract,
  CalendarJOB,
  ClientMessage,
  AddQuoteDiscount,
  Team,
  NoDataFound,
};
